import { useParams } from "react-router-dom";
import "./eventdetail.css";
import { useNavigate } from "react-router-dom";
import { getEventById, getPreviewEventByToken, getSessionByDayId, getAppSettings, addCartApi, getEventSponsor, createOrderApi, getCartApi, removeCartApi, getMyEventsApi, resolveReferralTokenApi } from "../../api/api";
import { getPreviewTokenFromSearch, getStoredPreviewToken, setPreviewBlockedMessage, clearPreviewBlockedMessage } from "../../helpers/preview";
import { getReferralTokenFromSearch, getStoredEventReferral, storeEventReferral, clearStoredEventReferral } from "../../helpers/referral";
import { useState, useEffect, useRef, useMemo } from "react";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { Row, Col, Card, Button, Modal } from "react-bootstrap";
import DateIcon from "../../assets/date.svg";
import Time from "../../assets/time.svg";
import Location from "../../assets/location.svg";
import room from "../../assets/room.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import { useMediaQuery } from "react-responsive";
import { useForm } from "react-hook-form";
import { Rating } from "react-simple-star-rating";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import visa from "../../assets/image/Cards/campanas copia 12.svg";
import maestro from "../../assets/image/Cards/Maestro_2016.svg copia.svg";
import mastercard from "../../assets/image/Cards/Mastercard-logo.svg copia.svg";
import american from "../../assets/image/Cards/campanas copia 1.svg";
import argencard from "../../assets/image/Cards/b69b09bc-00db-435c-b79b-fe88d15c121d 1.svg";
import dinners from "../../assets/image/Cards/logo-Diners-Club-International copia.svg";
import cabal from "../../assets/image/Cards/campanas copia 2.svg";
import mp from "../../assets/image/wallets/campanas copia 1.svg";
import bna from "../../assets/image/wallets/campanas copia 2.svg";
import uala from "../../assets/image/wallets/campanas copia 3.svg";
import claropay from "../../assets/image/wallets/campanas copia 4.svg";
import modo from "../../assets/image/wallets/campanas copia 5.svg";
import naranja from "../../assets/image/wallets/campanas copia 6.svg";
import personal from "../../assets/image/wallets/campanas copia 7.svg";
import cuentaDni from "../../assets/image/wallets/campanas copia 8.svg";
import cruze from "../../assets/image/flecha-hacia-abajo-para-navegar 8.svg";
import cherow from "../../assets/image/flecha-hacia-abajo-para-navegarBlanca.svg";
import not from "../../assets/image/archivo 1.svg";
import campana from "../../assets/image/campana-de-notificacion 1.svg";
import triste from "../../assets/image/triste 1.svg";
import Calendar  from "../../assets/image/calendario 1.svg";
import ubi  from "../../assets/image/ubicacion 1.svg";
import reloj from "../../assets/image/reloj-de-pared 1.svg";
import eliminar from "../../assets/image/eliminar 1.svg";
import ticket from "../../assets/image/boleto-2 1.svg";
import qrscanner from "../../assets/image/codigo-qr 1.svg";
import tranferencia from "../../assets/image/transferencia-de-datos 1.svg";
import cherowB from "../../assets/image/flecha-hacia-abajo-para-navegar 1.svg";
import { useDispatch, useSelector } from "react-redux";
import Marquee from "react-fast-marquee";
import SpinLoading from "../../components/spinLoading/SpinLoading";
import FloatingAppButton from "../../components/FloatingAppButton";
import { handleError } from "../../helpers/handleError";
import { resolveTicketsPerUnit } from "../../helpers/ticketTypes";
import { PAYMENT_API, PAYMENT_REDIRECT_BASE } from "../../api/apilist";
import { jwtDecode } from "jwt-decode";
import instagramIcon from "../../assets/image/instagram-brands-solid-full.svg";
import shareIcon from "../../assets/image/arrow-up-from-bracket-solid-full (1).svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FISERV_CARD_OPTIONS, calculateInstallmentTotal } from "../../constants/fiservPaymentOptions";
import {
  getResolvedMetaPixelId,
  loadMetaPixel,
  normalizeMetaCurrency,
  trackMetaPixel,
} from "../../helpers/metaPixel";
import {
  calculateChargedQuantity,
  calculateTicketLineTotal,
  getPromotionLabel,
  normalizeTicketPromotion,
} from "../../helpers/ticketPromotions";

const EventDetail = () => {
  const [rating, setRating] = useState(0);
  const dispatch = useDispatch();
  const { id, token: previewTokenParam } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState([]);
  const metaPixelViewTrackedRef = useRef("");
  const metaPixelCheckoutTrackedRef = useRef(false);
  const [day, setDay] = useState([]);
  const [session, setSession] = useState([]);
  const [categoryhaderimage, setCategoryhaderimage] = useState("");
  const location = useLocation();
  const { state } = location;
  const previewToken =
    previewTokenParam ||
    getPreviewTokenFromSearch(location.search) ||
    getStoredPreviewToken();
  const isPreview = Boolean(previewToken);
  const referralTokenFromSearch = useMemo(
    () => getReferralTokenFromSearch(location.search),
    [location.search]
  );
  const [storedReferral, setStoredReferral] = useState(() =>
    id ? getStoredEventReferral(id) : null
  );
  const referralToken = isPreview ? "" : String(storedReferral?.token || "");
  const [activeday, setActiveday] = useState();
  const isTablet = useMediaQuery({ query: "(max-width: 991px)" });
  const token = useSelector((state) => state.auth.accessToken);
  const [relatedevent, setRelatedevent] = useState([]);
  const [appSettings, setAppSettings] = useState({});
  const [alreadyPurchased, setAlreadyPurchased] = useState(0);
  const [video, setVideo] = useState("");
  const [image, setImage] = useState("");
  const [visible, setVisible] = useState(false);
  const [imageview, setImageview] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [pendingCheckoutAction, setPendingCheckoutAction] = useState(null);
  const [confirmedPaymentSelection, setConfirmedPaymentSelection] = useState(null);
  const [modalCard, setModalCard] = useState("");
  const [modalInstallment, setModalInstallment] = useState("");
  const [showPaymentBreakdown, setShowPaymentBreakdown] = useState(false);
  // Indicador de scroll para la columna izquierda
  const leftScrollRef = useRef(null);
  const [showScrollHint, setShowScrollHint] = useState(true);
  // Una vez que el usuario interactuÃ³, no volver a mostrar
  const [scrollHintDismissed, setScrollHintDismissed] = useState(false);
  // Estados de carga independientes para evitar parpadeos
  const [loadingEvent, setLoadingEvent] = useState(true);
  const [loadingApp, setLoadingApp] = useState(true);
  const [loadingSponsor, setLoadingSponsor] = useState(true);
  // QuÃ© botÃ³n estÃ¡ procesando una acciÃ³n (ticketTypeId o 'DEFAULT')
  const [loadingButtonId, setLoadingButtonId] = useState(null);
  const isLoading = loadingEvent || loadingApp || (!isPreview && loadingSponsor);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [reviewstate, setReviewstate] = useState(false);
  const [nav, setNav] = useState([]);
  const [eventSponsor, setEventSponsor] = useState([]);
  const [ticketTypes, setTicketTypes] = useState([]);
  const [selectedTicketDesc, setSelectedTicketDesc] = useState(null);
  // Carrito local por tipo de entrada
  const [typeQuantities, setTypeQuantities] = useState({});
  // Cantidades seleccionadas en la orden (derecha). Empieza vacÃ­o y se llena al presionar "Agregar" en las cards
  const [orderQuantities, setOrderQuantities] = useState({});
  const maxTicketsPerUser = useMemo(() => {
    const configured = Number(event?.maxTicketsPerUser || 0);
    if (Number.isFinite(configured) && configured > 0) return Math.trunc(configured);
    return 4;
  }, [event?.maxTicketsPerUser]);
  // Opt-in: novedades del organizador (estructura lista para email/whatsapp/push; por ahora solo email)
  const [organizerMarketingOptIn, setOrganizerMarketingOptIn] = useState(false);
  const marketingConsent = useMemo(() => {
    const optedIn = Boolean(organizerMarketingOptIn);
    return {
      optedIn,
      channels: {
        email: optedIn,
        whatsapp: false,
        push: false,
      },
      source: "event_detail:web",
    };
  }, [organizerMarketingOptIn]);

  useEffect(() => {
    if (!id || isPreview) {
      setStoredReferral(null);
      return;
    }
    setStoredReferral(getStoredEventReferral(id));
  }, [id, isPreview, location.search]);

  useEffect(() => {
    if (!id || isPreview) return;
    if (!referralTokenFromSearch) return;
    let cancelled = false;

    resolveReferralTokenApi(referralTokenFromSearch)
      .then((res) => {
        const info = res?.data?.info || {};
        if (String(info.eventId || "") !== String(id)) {
          clearStoredEventReferral(id);
          if (!cancelled) setStoredReferral(null);
          return;
        }
        const saved = storeEventReferral({
          eventId: id,
          token: referralTokenFromSearch,
          code: info.code || "",
          expiresAt: info.expiresAt || null,
          sellerId: info.sellerId || null,
        });
        if (!cancelled) setStoredReferral(saved);
      })
      .catch(() => {
        clearStoredEventReferral(id);
        if (!cancelled) setStoredReferral(null);
      });

    return () => {
      cancelled = true;
    };
  }, [id, isPreview, referralTokenFromSearch]);

  useEffect(() => {
    if (!id || isPreview || !referralTokenFromSearch) return;
    const userAgent = String(window.navigator?.userAgent || "");
    const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(userAgent);
    if (!isMobileDevice) return;

    const sessionKey = `referral-app-open-attempt:${id}:${referralTokenFromSearch}`;
    try {
      if (sessionStorage.getItem(sessionKey)) return;
      sessionStorage.setItem(sessionKey, "1");
    } catch (_) {}

    const appUrl = `zoco-tickets://event/${encodeURIComponent(id)}?r=${encodeURIComponent(referralTokenFromSearch)}`;
    const timer = window.setTimeout(() => {
      window.location.href = appUrl;
    }, 250);

    return () => {
      window.clearTimeout(timer);
    };
  }, [id, isPreview, referralTokenFromSearch]);

  const [checkingOut, setCheckingOut] = useState(false);
  const [modoLoading, setModoLoading] = useState(false);
  const [modoError, setModoError] = useState("");
  const [previewError, setPreviewError] = useState("");
  // Mobile-only UI helpers
  const isMobile = useMediaQuery({ query: "(max-width: 640px)" });
  const [descExpanded, setDescExpanded] = useState(false);
  const ticketsRef = useRef(null);
  const handleShare = async () => {
    try {
      const shareData = {
        title: event?.name || 'Evento',
        text: 'Mirá este evento en Zoco',
        url: (typeof window !== 'undefined' && window.location && window.location.href) ? window.location.href : ''
      };
      if (navigator && typeof navigator.share === 'function') {
        await navigator.share(shareData);
      } else if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(shareData.url);
        toast.success('Enlace copiado al portapapeles');
      }
    } catch (_) {
      try {
        const url = (typeof window !== 'undefined' && window.location && window.location.href) ? window.location.href : '';
        if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
          await navigator.clipboard.writeText(url);
          toast.success('Enlace copiado al portapapeles');
        }
      } catch {}
    }
  };
  const openInstagram = () => {
    try {
      const candidates = [
        event?.instagram,
        event?.instagramUrl,
        event?.instagramLink,
        event?.social?.instagram,
        appSettings?.instagram
      ];
      const url = candidates.find(v => typeof v === 'string' && v.trim().length > 0);
      if (url) {
        const href = url.startsWith('http') ? url : `https://www.instagram.com/${url.replace(/^@/, '')}`;
        window.open(href, '_blank');
      } else {
        window.open('https://www.instagram.com/', '_blank');
      }
    } catch (_) {
      try { window.open('https://www.instagram.com/', '_blank'); } catch {}
    }
  };
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [expandedDescs, setExpandedDescs] = useState({});
  const toggleDesc = (id) => setExpandedDescs((prev) => ({ ...prev, [id]: !prev[id] }));
  // UI: sección información útil + lista de espera

  // Ocultar indicador SOLO cuando se hace scroll en la columna izquierda
  // y no volver a mostrarlo despuÃ©s de la primera interacciÃ³n
  useEffect(() => {
    const el = leftScrollRef.current;
    if (!el) return;
    const handle = () => {
      try {
        const canScroll = el.scrollHeight > el.clientHeight + 2;
        const canWindowScroll =
          typeof window !== "undefined" &&
          document?.documentElement?.scrollHeight > window.innerHeight + 2;
        if (!canScroll && !canWindowScroll) { setShowScrollHint(false); return; }
        if (scrollHintDismissed) { setShowScrollHint(false); return; }
        if (el.scrollTop >= 20 || (canWindowScroll && window.scrollY >= 20)) { setScrollHintDismissed(true); setShowScrollHint(false); return; }
        setShowScrollHint(true);
      } catch (_) {}
    };
    handle();
    el.addEventListener('scroll', handle, { passive: true });
    window.addEventListener('scroll', handle, { passive: true });
    return () => {
      el.removeEventListener('scroll', handle);
      window.removeEventListener('scroll', handle);
    };
  }, [scrollHintDismissed]);

  const scrollDown = () => {
    try {
      const el = leftScrollRef.current;
      if (el && el.scrollHeight > el.clientHeight) {
        el.scrollBy({ top: 400, behavior: 'smooth' });
      } else {
        window.scrollBy({ top: 400, behavior: 'smooth' });
      }
      setScrollHintDismissed(true);
      setShowScrollHint(false);
    } catch (_) {}
  };
  // Handlers directos por si el contenedor no emite "scroll" (por inercia del navegador)
  const handleLeftScrollEvent = () => {
    const el = leftScrollRef.current;
    if (!el) return;
    try {
      const canScroll = el.scrollHeight > el.clientHeight + 2;
      const canWindowScroll =
        typeof window !== "undefined" &&
        document?.documentElement?.scrollHeight > window.innerHeight + 2;
      if (!canScroll && !canWindowScroll) { setShowScrollHint(false); return; }
      if (scrollHintDismissed) { setShowScrollHint(false); return; }
      if (el.scrollTop >= 20 || (canWindowScroll && window.scrollY >= 20)) { setScrollHintDismissed(true); setShowScrollHint(false); return; }
      setShowScrollHint(true);
    } catch (_) {}
  };
  const handleLeftGesture = () => {
    // Ocultar al primer gesto (rueda/touch) sobre la columna izquierda
    setScrollHintDismissed(true);
    setShowScrollHint(false);
  };
  // Coordenadas seguras desde distintas formas que puede venir el evento
  const getCoords = (ev) => {
    // Event's own pin first; legacy events fall back to their venue's coords
    const latRaw = ev?.lat ?? ev?.venueid?.latitude ?? ev?.latitude ?? ev?.venue?.latitude;
    const lngRaw = ev?.lng ?? ev?.venueid?.longitude ?? ev?.longitude ?? ev?.venue?.longitude;
    const lat = Number(latRaw);
    const lng = Number(lngRaw);
    if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
    return null;
  };
  // Construye una query para Google Maps: usa coordenadas si existen; si no, direcciÃ³n textual
  const getMapQuery = (ev) => {
    try {
      const c = getCoords(ev);
      if (c) return `${c.lat},${c.lng}`;
      const parts = [];
      const addr = ev?.fulladdress || ev?.address || ev?.venueid?.address || ev?.venue?.address;
      if (addr) parts.push(String(addr));
      const city = ev?.venueid?.city?.name || ev?.city?.name || ev?.venue?.city || ev?.city;
      if (city) parts.push(String(city));
      const state = ev?.venueid?.state?.name || ev?.state?.name || ev?.venue?.state || ev?.state;
      if (state) parts.push(String(state));
      const country = ev?.venueid?.country?.name || ev?.country?.name || "Argentina";
      if (country) parts.push(String(country));
      const q = parts.filter(Boolean).join(", ");
      return q ? encodeURIComponent(q) : null;
    } catch (_) {
      return null;
    }
  };
  const [waitEmail, setWaitEmail] = useState('');
  const [waitSaved, setWaitSaved] = useState(false);
  const swipereventRef = useRef(null);
  const handleFirstClick = () => {
    if (swipereventRef.current) {
      swipereventRef.current.slideTo(swipereventRef.current.activeIndex);
    }
  };

  const handleLastClick = () => {
    if (swipereventRef.current) {
      swipereventRef.current.slideTo(swipereventRef.current.activeIndex);
    }
  };
  const handleWaitSubmit = (e) => {
    e.preventDefault();
    if (!waitEmail || !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(waitEmail)) return;
    setWaitSaved(true);
    setTimeout(()=> setWaitSaved(false), 3500);
  };
  // Imagen principal del hero: prioriza galería por dispositivo, luego legado (multipleImage), luego portada
  const heroImage = (() => {
    try {
      const list = Array.isArray(event?.multipleImage) ? event.multipleImage : [];
      const firstImage = list.find((u) => typeof u === 'string' && /(\.jpe?g|\.png|\.webp|\.gif)$/i.test(u));
      const galleryDesktop =
        event?.galleryimage || event?.galleryImage || event?.galleryDesktopImage || "";
      const galleryMobile =
        event?.gallerymobileimage || event?.galleryMobileImage || event?.galleryMobile || "";
      const deviceGallery = isMobile ? galleryMobile : galleryDesktop;
      return deviceGallery || firstImage || event?.image || categoryhaderimage || '';
    } catch (_) {
      return event?.image || categoryhaderimage || '';
    }
  })();

  const desktopGalleryImage = (() => {
    try {
      const galleryDesktop =
        event?.galleryimage || event?.galleryImage || event?.galleryDesktopImage || "";
      if (galleryDesktop) return galleryDesktop;
      const list = Array.isArray(event?.multipleImage) ? event.multipleImage : [];
      return list.find((u) => typeof u === 'string') || event?.image || "";
    } catch (_) {
      return "";
    }
  })();

  useEffect(() => {
    if (isPreview) return;
    const eventId = event?._id || event?.id || id;
    if (!eventId) return;

    const pixelId = getResolvedMetaPixelId(event || {});
    const trackKey = `${eventId}:${pixelId}`;
    if (metaPixelViewTrackedRef.current === trackKey) return;
    if (!loadMetaPixel(pixelId)) return;

    metaPixelViewTrackedRef.current = trackKey;
    trackMetaPixel("ViewContent", {
      content_name: event?.title || event?.name || "Evento",
      content_ids: [String(eventId)],
      content_type: "event",
    });
  }, [event, id, isPreview]);

  useEffect(() => {
    metaPixelCheckoutTrackedRef.current = false;
  }, [id]);

  // Compras previas del usuario para este evento (para respetar mÃ¡ximo por persona)
  useEffect(() => {
    const loadMyPurchases = async () => {
      try {
        if (isPreview) {
          setAlreadyPurchased(0);
          return;
        }
        if (!token || !id) { setAlreadyPurchased(0); return; }
        const res = await getMyEventsApi(token);
        const list = Array.isArray(res?.data?.info) ? res.data.info : [];
        const found = list.find((ev) => {
          const evId = ev?.eventid || ev?.id || ev?._id;
          return String(evId || '') === String(id || '');
        });
        if (!found) { setAlreadyPurchased(0); return; }
        const candidates = [found.ticketsPurchased, found.totalTickets, found.count];
        let n = 0;
        for (const c of candidates) { if (typeof c !== 'undefined') { n = Number(c || 0); break; } }
        if (!n && Array.isArray(found.tickets)) {
          try { n = found.tickets.length || 0; } catch (_) {}
        }
        setAlreadyPurchased(Math.max(0, n || 0));
      } catch (_) {
        setAlreadyPurchased(0);
      }
    };
    loadMyPurchases();
  }, [token, id, isPreview]);
  // Restaurar selecciÃ³n desde lastCheckoutCtx (fallback) si coincide el evento
  useEffect(() => {
    if (isPreview) return;
    if (!id) return;
    try {
      const raw = localStorage.getItem("lastCheckoutCtx");
      if (!raw) return;
      const data = JSON.parse(raw);
      if (!data || data.eventId !== id) return;
      if (data.quantities && typeof data.quantities === 'object') {
        setOrderQuantities((prev) => ({ ...prev, ...data.quantities }));
      }
    } catch {}
  }, [id, isPreview]);
  // Recordar el Ãºltimo evento visitado para volver tras login
  useEffect(() => {
    if (isPreview) return;
    if (!id) return;
    try { localStorage.setItem("lastEventId", id); } catch {}
  }, [id, isPreview]);
  // Si hay clave de reanudaciÃ³n en pendingCheckout, traer snapshot del backend y fusionar cantidades
  useEffect(() => {
    try {
      if (isPreview) return;
      const raw = localStorage.getItem("pendingCheckout");
      if (!raw) return;
      const data = JSON.parse(raw);
      if (!data || data.eventId !== id) return;
      if (typeof data?.marketingConsent?.optedIn === "boolean") {
        setOrganizerMarketingOptIn(Boolean(data.marketingConsent.optedIn));
      }
      if (!token) return;
      const key = data.resumeKey;
      if (!key) return;
      (async () => {
        try {
          const r = await fetch(`${PAYMENT_API}/api/payment/fiserv/pending/${encodeURIComponent(key)}`);
          const j = await r.json();
          if (r.ok && j?.info?.items) {
            const map = {};
            for (const it of j.info.items) {
              const ttId = it?.ticketTypeId;
              const qty = Number(it?.quantity || 0);
              if (!qty) continue;
              if (ttId) map[ttId] = (map[ttId] || 0) + qty; else map['DEFAULT'] = (map['DEFAULT'] || 0) + qty;
            }
            if (map.DEFAULT) {
              const priceNum = Number(event?.price || 0);
              const keyId = (event?.isFree || priceNum <= 0) ? 'FREE_DEFAULT' : 'PAID_DEFAULT';
              map[keyId] = (map[keyId] || 0) + map.DEFAULT;
              delete map.DEFAULT;
            }
            setOrderQuantities((prev) => ({ ...prev, ...map }));
          }
        } catch (_) {}
      })();
    } catch {}
  }, [id, token, isPreview]);

  // Persistir opt-in como borrador para reanudar (por evento)
  useEffect(() => {
    if (isPreview) return;
    if (!id) return;
    try {
      localStorage.setItem(
        `draftMarketingConsent:${id}`,
        JSON.stringify({ optedIn: Boolean(organizerMarketingOptIn) })
      );
    } catch {}
  }, [id, organizerMarketingOptIn, isPreview]);

  // Restaurar opt-in del borrador si existe
  useEffect(() => {
    if (isPreview) return;
    if (!id) return;
    try {
      const raw = localStorage.getItem(`draftMarketingConsent:${id}`);
      if (!raw) return;
      const saved = JSON.parse(raw);
      if (typeof saved?.optedIn === "boolean") {
        setOrganizerMarketingOptIn(Boolean(saved.optedIn));
      }
    } catch {}
  }, [id, isPreview]);

  // Persistir selecciÃ³n local como borrador para reanudar despuÃ©s de login
  useEffect(() => {
    if (isPreview) return;
    if (!id) return;
    try {
      const key = `draftOrder:${id}`;
      if (orderQuantities && Object.keys(orderQuantities).length > 0) {
        localStorage.setItem(key, JSON.stringify(orderQuantities));
      } else {
        localStorage.removeItem(key);
      }
    } catch {}
  }, [id, orderQuantities, isPreview]);

  // Restaurar borrador si existe
  useEffect(() => {
    if (isPreview) return;
    if (!id) return;
    try {
      const raw = localStorage.getItem(`draftOrder:${id}`);
      if (!raw) return;
      const saved = JSON.parse(raw);
      if (saved && typeof saved === 'object') setOrderQuantities(saved);
    } catch {}
  }, [id, isPreview]);
  const fetchAppSettings = async () => {
    try {
      setLoadingApp(true);
      const response = await getAppSettings();
      if (response.status === 200) {
        setAppSettings(response.data.info);
      }
    } catch (error) {
      handleError(error);      
    } finally {
      setLoadingApp(false);
    }
  };

  const onSubmit = (event) => {
    setReviewstate(true);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      reset();
      setReviewstate(false);
    }, 3000);
  };

  const fetchEventSponsor = async (eventIdOverride = null) => {
    const eventId = eventIdOverride || id;
    if (isPreview || !eventId) {
      setLoadingSponsor(false);
      return;
    }
    try {
      setLoadingSponsor(true);
      const res = await getEventSponsor({ eventid: eventId });
      if (res.status === 200) {
        setEventSponsor(res.data.info);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingSponsor(false);
    }
  };

  const fetchEvent = async () => {
    try {
      setLoadingEvent(true);
      setPreviewError("");
      const usePreviewEndpoint = Boolean(previewTokenParam) && !id;
      if (usePreviewEndpoint) {
        const res = await getPreviewEventByToken(previewToken);
        if (res.status === 200) {
          clearPreviewBlockedMessage();
          setEvent(res.data.info.event);
          setCategoryhaderimage(res?.data?.info?.event?.headerimage || image);
          setDay(res?.data?.info?.day);
          setActiveday(res?.data?.info?.day[0]?._id);
          setSession(res?.data?.info?.session);
          setRelatedevent([]);
          const types = res?.data?.info?.ticketTypes || [];
          setTicketTypes(types);
          const init = {};
          for (const t of types) {
            if (t?.id) init[t.id] = 0;
          }
          setTypeQuantities(init);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        if (!id) {
          setLoadingEvent(false);
          return;
        }
        const res = await getEventById(id);

        if (res.status === 200) {
          setEvent(res.data.info.event);
          setCategoryhaderimage(res?.data?.info?.event?.headerimage || image);
          setDay(res?.data?.info?.day);
          setActiveday(res?.data?.info?.day[0]?._id);
          setSession(res?.data?.info?.session);
          setRelatedevent(res?.data?.info?.relatedEvent);
          const types = res?.data?.info?.ticketTypes || [];
          setTicketTypes(types);
          // Inicializar cantidades en 0 para cada tipo de entrada
          const init = {};
          for (const t of types) {
            if (t?.id) init[t.id] = 0;
          }
          setTypeQuantities(init);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }
    } catch (error) {
      handleError(error);
      const usePreviewEndpoint = Boolean(previewTokenParam) && !id;
      if (usePreviewEndpoint) {
        const status = error?.response?.status;
        const message = error?.response?.data?.message || "Vista previa no disponible";
        const msgLower = String(message || "").toLowerCase();
        const shouldBlock =
          [403, 410, 429].includes(status) ||
          (status === 404 && (msgLower.includes("link") || msgLower.includes("no encontrado") || msgLower.includes("no disponible")));
        setPreviewError(message);
        if (shouldBlock) {
          setPreviewBlockedMessage(message);
        }
      } else {
        navigate(-1);
      }
    } finally {
      setLoadingEvent(false);
    }
  };

  const fetchSessio = async (activeday) => {
    if (activeday) {
      try {
        setLoadingEvent(true);
        const data = {
          dayid: activeday,
        };
        const res = await getSessionByDayId(data);

        if (res.status === 200) {
          setSession(res?.data?.info);
        }
      } catch (error) {
        handleError(error);
      } finally {
        setLoadingEvent(false);
      }
    }
  };

  const addCart = async (ticketTypeId = null, quantity = 1) => {
    try {
      if (isPreview) return;
      setLoadingButtonId(ticketTypeId ?? 'DEFAULT');
      trackAddToCartEvent({ ticketTypeId, quantity, source: "event_detail_buy_now" });
      if (token) {
        const payload = { eventId: id, quantity: Number(quantity) || 1 };
        if (ticketTypeId) payload.ticketTypeId = ticketTypeId;
        const res = await addCartApi(payload, token);
        if (res.status === 200) {
          navigate("/cart");
        }
      } else {
        try {
          localStorage.setItem(
            "pendingCheckout",
            JSON.stringify({ provider: 'fiserv', eventId: id, quantities: orderQuantities, marketingConsent, ts: Date.now() })
          );
        } catch {}
        navigate("/login", { state: { from: `/event/${id}`, reason: "checkout" } });
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoadingButtonId(null);
    }
  };
  const buyTypeHandler = (typeId) => addCart(typeId);

  // Helpers de cantidades para el carrito lateral
  const setQty = (typeId, qty) => {
    setTypeQuantities((prev) => ({
      ...prev,
      [typeId]: Math.max(0, Math.min(99, Number.isFinite(qty) ? qty : 0)),
    }));
  };

  const incQty = (typeId) =>
    setTypeQuantities((prev) => ({ ...prev, [typeId]: Math.min(99, (prev[typeId] || 0) + 1) }));
  const decQty = (typeId) =>
    setTypeQuantities((prev) => ({ ...prev, [typeId]: Math.max(0, (prev[typeId] || 0) - 1) }));

  const getTypePrice = (t) => Number(t?.price || 0);
  const getTypePromotion = (t) => normalizeTicketPromotion(t?.promotion);
  const getTypeLineTotal = (t, quantity) => calculateTicketLineTotal(getTypePrice(t), quantity, getTypePromotion(t));
  const getTypeChargedQty = (t, quantity) => calculateChargedQuantity(quantity, getTypePromotion(t));
  const getTypeDisplayPrice = (t, quantity = 0) => {
    const unitPrice = getTypePrice(t);
    if (unitPrice <= 0) return "Gratis";

    const safeQty = Math.max(0, Number(quantity) || 0);
    const amountToShow = safeQty > 0 ? getTypeLineTotal(t, safeQty) : unitPrice;
    return `${appSettings.currency} ${Number(amountToShow || 0).toLocaleString()}`;
  };
  // Custom lightweight select to allow green hover in options (native select can't be styled)
  const QtySelect = ({ value = '', options = [], onChange, disabled = false, className = '', placeholder = '' }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const normalizedOptions = useMemo(() => {
      if (!Array.isArray(options)) return [];
      return options.map((opt) => ({
        value: opt.value,
        label: opt.label ?? opt.value,
        disabled: Boolean(opt.disabled),
      }));
    }, [options]);
    const selectedOption = normalizedOptions.find((opt) => String(opt.value) === String(value)) || null;
    const hasValue = Boolean(selectedOption) && !selectedOption.disabled;
    const displayValue = hasValue
      ? String(selectedOption.label ?? selectedOption.value ?? '')
      : placeholder
        ? String(placeholder)
        : String(value ?? '');
    useEffect(() => {
      const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
      document.addEventListener('mousedown', onDoc);
      return () => document.removeEventListener('mousedown', onDoc);
    }, []);
    useEffect(() => {
      if (disabled && open) setOpen(false);
    }, [disabled, open]);
    const toggle = (e) => {
      if (disabled) return;
      if (e?.target && typeof e.target.closest === 'function' && e.target.closest('.ui-options')) return;
      setOpen((o) => !o);
    };
    const onKey = (e) => {
      if (disabled) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen((o) => !o); }
      if (e.key === 'Escape') setOpen(false);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        const enabledOptions = normalizedOptions.filter((opt) => !opt.disabled);
        if (!enabledOptions.length) return;
        const currentIdx = enabledOptions.findIndex((opt) => String(opt.value) === String(value));
        const dir = e.key === 'ArrowDown' ? 1 : -1;
        let nextIdx;
        if (currentIdx === -1) {
          nextIdx = dir === 1 ? 0 : enabledOptions.length - 1;
        } else {
          nextIdx = Math.min(enabledOptions.length - 1, Math.max(0, currentIdx + dir));
        }
        const nextOpt = enabledOptions[nextIdx];
        if (nextOpt && onChange) onChange(nextOpt.value);
      }
    };
    const pick = (opt) => {
      if (!opt || opt.disabled) return;
      setOpen(false);
      if (onChange) onChange(opt.value);
    };
    const containerClass = ['ui-select', className, disabled ? 'is-disabled' : '', open ? 'is-open' : '', !hasValue && placeholder ? 'is-placeholder' : '']
      .filter(Boolean)
      .join(' ');
    return (
      <div
        ref={ref}
        className={containerClass}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={onKey}
        onClick={toggle}
        role="listbox"
        aria-expanded={open}
        aria-disabled={disabled}
      >
        <div className="ui-select-value">{displayValue}</div>
        <div className="ui-options" style={{ display: open ? 'block' : 'none' }}>
          {placeholder ? (
            <div
              key="placeholder"
              className="ui-option is-disabled"
              role="option"
              aria-selected={!hasValue}
              aria-disabled="true"
              onMouseDown={(e) => e.preventDefault()}
              onClick={(e) => e.stopPropagation()}
            >
              {String(placeholder)}
            </div>
          ) : null}
          {normalizedOptions.map((opt) => {
            const isSelected = String(opt.value) === String(value);
            return (
              <div
                key={String(opt.value)}
                className={`ui-option ${isSelected ? 'is-selected' : ''} ${opt.disabled ? 'is-disabled' : ''}`}
                role="option"
                aria-selected={isSelected}
                aria-disabled={opt.disabled}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => pick(opt)}
              >
                {String(opt.label ?? opt.value)}
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  // Tipos visibles en UI: si no hay tipos y el evento es gratis, mostrar uno por defecto
  const uiTicketTypes = useMemo(() => {
    if (Array.isArray(ticketTypes) && ticketTypes.length > 0) return ticketTypes;
    if (event?.isFree) return [{ id: 'FREE_DEFAULT', name: 'General', price: 0, remaining: null, status: true }];
    const priceNum = Number(event?.price || 0);
    if (Number.isFinite(priceNum) && priceNum > 0) {
      return [{ id: 'PAID_DEFAULT', name: 'General', price: priceNum, remaining: null, status: true }];
    }
    return [];
  }, [ticketTypes, event?.isFree, event?.price]);

  const orderSubtotal = (uiTicketTypes || []).reduce((sum, t) => {
    const q = Number(orderQuantities[t.id] || 0);
    return sum + getTypeLineTotal(t, q);
  }, 0);

  // Servicio: 10% del subtotal (solo informativo en UI)
  const servicePercent = 0.10;
  const serviceFee = Math.round(orderSubtotal * servicePercent);

  // Orden vacÃ­a: no hay ninguna cantidad > 0 seleccionada
  const isOrderEmpty = useMemo(() => {
    if (!Array.isArray(uiTicketTypes) || uiTicketTypes.length === 0) {
      // Cuando no hay tipos reales (fallback de precio Ãºnico), no bloqueamos el botÃ³n
      return false;
    }
    return uiTicketTypes.every((tt) => (Number(orderQuantities[tt.id] || 0) <= 0));
  }, [uiTicketTypes, orderQuantities]);

  // Sumas auxiliares para deshabilitar acciones si supera el mÃ¡ximo por persona
  const totalSelected = useMemo(() => {
    return Object.values(orderQuantities || {}).reduce((s, q) => s + (Number(q) || 0), 0);
  }, [orderQuantities]);
  const allowedLeft = Math.max(0, maxTicketsPerUser - (alreadyPurchased || 0));
  const exceedsMax = totalSelected > allowedLeft;
  const isFreeOrder = useMemo(() => {
    if (Boolean(event?.isFree)) return true;
    return (Number(orderSubtotal) || 0) <= 0 && !isOrderEmpty;
  }, [event?.isFree, orderSubtotal, isOrderEmpty]);

  const cardOptions = useMemo(() => {
    const fromSettings = appSettings?.fiserv_card_options || appSettings?.fiservCardOptions;
    if (Array.isArray(fromSettings) && fromSettings.length) return fromSettings;
    return FISERV_CARD_OPTIONS;
  }, [appSettings]);
  const selectedCardOption = useMemo(() => {
    return cardOptions.find((opt) => opt.id === modalCard) || null;
  }, [cardOptions, modalCard]);
  const installmentOptions = selectedCardOption?.installments || [];
  const selectedInstallmentOption = useMemo(() => {
    return installmentOptions.find((opt) => Number(opt.value) === Number(modalInstallment)) || null;
  }, [installmentOptions, modalInstallment]);
  const modalTotalWithInterest = useMemo(() => {
    return calculateInstallmentTotal(orderSubtotal, selectedInstallmentOption?.rate ?? 0);
  }, [orderSubtotal, selectedInstallmentOption]);
  const modalInstallmentAmount = useMemo(() => {
    if (!selectedInstallmentOption || !selectedInstallmentOption.value) return null;
    const count = Number(selectedInstallmentOption.value) || 0;
    if (!count) return null;
    return modalTotalWithInterest / count;
  }, [modalTotalWithInterest, selectedInstallmentOption]);
  const modalInterestAmount = useMemo(() => {
    const total = Number(modalTotalWithInterest) || 0;
    const base = Number(orderSubtotal) || 0;
    return Math.max(0, total - base);
  }, [modalTotalWithInterest, orderSubtotal]);
  const installmentCount = Number(selectedInstallmentOption?.value) || 0;
  const installmentLabel = selectedInstallmentOption?.label
    ? selectedInstallmentOption.label
    : installmentCount
      ? `${installmentCount} cuota${installmentCount === 1 ? "" : "s"}`
      : "";
  const showInstallmentSummary = Boolean(selectedCardOption && selectedInstallmentOption && modalInstallmentAmount !== null);

  useEffect(() => {
    if (!selectedInstallmentOption) {
      setShowPaymentBreakdown(false);
    }
  }, [selectedInstallmentOption]);

  useEffect(() => {
    if (typeof document === "undefined") return;
    const bodyEl = document.body;
    if (!bodyEl) return;
    const className = "payment-modal-open";
    if (showPaymentModal) {
      bodyEl.classList.add(className);
    } else {
      bodyEl.classList.remove(className);
    }
    return () => {
      bodyEl.classList.remove(className);
    };
  }, [showPaymentModal]);

  const formatCurrency = (value) => {
    const symbol = (appSettings?.currency || "").trim();
    const amount = Number(value || 0);
    const formatted = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return symbol ? `${symbol} ${formatted}` : formatted;
  };

  const roundCurrency = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return 0;
    return Math.round(num * 100) / 100;
  };

  const buildCheckoutContext = () => {
    const entries = Object.entries(orderQuantities || {}).filter(([, q]) => (Number(q) || 0) > 0);
    const hasRealTypes = Array.isArray(ticketTypes) && ticketTypes.length > 0;
    const totalQty = entries.reduce((sum, [, q]) => sum + (Number(q) || 0), 0) || 1;

    if (hasRealTypes && entries.length === 0 && !event?.isFree) {
      toast.error("Seleccioná al menos una entrada");
      return null;
    }

    const items = (() => {
      if (!hasRealTypes) return [{ ticketTypeId: null, quantity: totalQty }];
      if (entries.length > 0) return entries.map(([typeId, qty]) => ({ ticketTypeId: typeId, quantity: Number(qty) || 1 }));
      // Fallback: si el evento es gratis y tiene tipos pero el usuario no seleccionó,
      // asumimos 1 del primer tipo disponible para evitar depender del carrito.
      if (event?.isFree && Array.isArray(ticketTypes) && ticketTypes.length > 0) {
        const first = ticketTypes.find((t) => t?.status !== false) || ticketTypes[0];
        const ttId = first?.id || null;
        return ttId ? [{ ticketTypeId: ttId, quantity: totalQty }] : [];
      }
      return [];
    })();

    try {
      const totalQtyForLimit = (items || []).reduce((s, it) => s + (Number(it.quantity) || 0), 0);
      const plannedTotal = (alreadyPurchased || 0) + totalQtyForLimit;
      if (plannedTotal > maxTicketsPerUser) {
        const left = Math.max(0, maxTicketsPerUser - (alreadyPurchased || 0));
        toast.error(
          left > 0
            ? `Máximo ${maxTicketsPerUser} entradas por persona para este evento. Ya tenés ${alreadyPurchased}; podés seleccionar hasta ${left}.`
            : `Alcanzaste el máximo de ${maxTicketsPerUser} entradas para este evento.`
        );
        return null;
      }
    } catch (_) {}

    const selectionTotal = (() => {
      if (Boolean(event?.isFree)) return 0;
      if (!hasRealTypes) {
        const basePrice = Number(event?.price || 0);
        return basePrice * totalQty;
      }
      let total = 0;
      for (const [typeId, qty] of entries) {
        const t = (ticketTypes || []).find((tt) => tt.id === typeId);
        total += getTypeLineTotal(t, Number(qty) || 0);
      }
      return total;
    })();

    const selectionIsFree = selectionTotal <= 0;

    return {
      entries,
      hasRealTypes,
      totalQty,
      items,
      selectedItems: hasRealTypes ? items : [],
      selectionIsFree,
      selectionTotal,
    };
  };

  const trackInitiateCheckout = (context) => {
    if (isPreview || metaPixelCheckoutTrackedRef.current || !context) return;
    const pixelId = getResolvedMetaPixelId(event || {});
    if (!loadMetaPixel(pixelId)) return;
    metaPixelCheckoutTrackedRef.current = true;
    trackMetaPixel("InitiateCheckout", {
      value: Number(context.selectionTotal || orderSubtotal || 0),
      currency: normalizeMetaCurrency(appSettings?.currency_string || appSettings?.currency || "ARS"),
    });
  };

  const trackAddToCartEvent = ({ ticketTypeId = null, quantity = 1, source = "event_detail" } = {}) => {
    if (isPreview) return;
    const pixelId = getResolvedMetaPixelId(event || {});
    if (!loadMetaPixel(pixelId)) return;

    const ticketType = (ticketTypes || []).find((item) => String(item.id) === String(ticketTypeId));
    const safeQuantity = Math.max(1, Number(quantity) || 1);
    const lineValue = ticketType
      ? getTypeLineTotal(ticketType, safeQuantity)
      : Number(event?.price || 0) * safeQuantity;

    trackMetaPixel("AddToCart", {
      content_name: event?.title || event?.name || "Evento",
      content_ids: [String(ticketTypeId || event?._id || id || "event")],
      content_type: ticketTypeId ? "ticket" : "event",
      value: Number(lineValue || 0),
      currency: normalizeMetaCurrency(appSettings?.currency_string || appSettings?.currency || "ARS"),
      num_items: safeQuantity,
      source,
    });
  };

  const normalizeSelection = (candidate, baseAmountHint) => {
    if (!candidate) return null;
    const candidateCardId = candidate.cardId || candidate.card?.id || candidate.id || "";
    const card =
      (candidate.card && Array.isArray(candidate.card.installments)) ?
        candidate.card :
        cardOptions.find((opt) => opt.id === candidateCardId);
    if (!card) return null;

    const rawInstallments =
      candidate.numberOfInstallments ??
      candidate.installments ??
      candidate.installment?.value ??
      candidate.installment ??
      0;
    const installment =
      (candidate.installment && candidate.installment.value != null)
        ? candidate.installment
        : (card.installments || []).find((opt) => Number(opt.value) === Number(rawInstallments));
    if (!installment) return null;

    const amountCandidates = [
      baseAmountHint,
      candidate.baseAmount,
      orderSubtotal,
      0,
    ];
    let baseAmount = 0;
    for (const raw of amountCandidates) {
      const num = Number(raw);
      if (Number.isFinite(num) && num >= 0) {
        baseAmount = num;
        break;
      }
    }
    const rate = Number(candidate.rate ?? installment.rate ?? 0) || 0;

    let total = Number(candidate.totalWithInterest);
    if (!Number.isFinite(total)) {
      total = calculateInstallmentTotal(baseAmount, rate);
    }
    total = roundCurrency(total);
    if (total < baseAmount) total = roundCurrency(baseAmount);

    let surcharge = Number(candidate.surcharge);
    if (!Number.isFinite(surcharge)) {
      surcharge = roundCurrency(total - baseAmount);
    } else {
      surcharge = roundCurrency(surcharge);
    }
    if (surcharge < 0) surcharge = 0;

    const count = Number(rawInstallments || installment.value || 0) || 0;
    const installmentAmount = count > 0 ? roundCurrency(total / count) : null;

    return {
      card,
      installment,
      cardId: card.id,
      cardLabel: candidate.cardLabel || card.label,
      storeId: card.storeId,
      installmentLabel: candidate.installmentLabel || installment.label,
      numberOfInstallments: count,
      installments: count,
      rate,
      baseAmount: roundCurrency(baseAmount),
      surcharge,
      totalWithInterest: total,
      installmentAmount,
    };
  };

  const resolveConfirmedSelection = (overrideSelection, baseAmountHint) => {
    if (overrideSelection) {
      return normalizeSelection(overrideSelection, baseAmountHint);
    }
    return normalizeSelection(confirmedPaymentSelection, baseAmountHint);
  };

  const computeInstallmentAmounts = (context, selection) => {
    const baseAmount = roundCurrency(
      (context && context.selectionTotal != null ? context.selectionTotal : undefined) ??
        selection?.baseAmount ??
        orderSubtotal ??
        0
    );
    const rate = Number(selection?.rate || 0) || 0;
    let chargeTotal = selection?.totalWithInterest;
    if (!Number.isFinite(chargeTotal)) {
      chargeTotal = calculateInstallmentTotal(baseAmount, rate);
    }
    chargeTotal = roundCurrency(chargeTotal);
    if (chargeTotal < baseAmount) chargeTotal = baseAmount;
    const surcharge = Math.max(0, roundCurrency(chargeTotal - baseAmount));
    const effectiveRate =
      baseAmount > 0
        ? Number((chargeTotal / baseAmount - 1).toFixed(6))
        : 0;
    const installmentAmount =
      selection?.numberOfInstallments > 0
        ? roundCurrency(chargeTotal / selection.numberOfInstallments)
        : null;
    return {
      baseAmount,
      rate,
      effectiveRate,
      surcharge,
      chargeTotal,
      installmentAmount,
    };
  };

  const resetPaymentFlowState = () => {
    setPendingCheckoutAction(null);
  };

  const requirePaymentSelection = (action) => {
    const fallbackCardId = (() => {
      if (modalCard && cardOptions.some((opt) => opt.id === modalCard)) return modalCard;
      if (confirmedPaymentSelection && cardOptions.some((opt) => opt.id === confirmedPaymentSelection.cardId)) {
        return confirmedPaymentSelection.cardId;
      }
      return cardOptions[0]?.id || "";
    })();

    const card = cardOptions.find((opt) => opt.id === fallbackCardId) || null;
    const fallbackInstallment = (() => {
      if (!card) return "";
      if (modalInstallment && card.installments?.some((opt) => Number(opt.value) === Number(modalInstallment))) {
        return String(modalInstallment);
      }
      if (
        confirmedPaymentSelection &&
        confirmedPaymentSelection.cardId === card.id &&
        card.installments?.some((opt) => Number(opt.value) === Number(confirmedPaymentSelection.installments))
      ) {
        return String(confirmedPaymentSelection.installments);
      }
      return card.installments?.length ? String(card.installments[0].value) : "";
    })();

    setModalCard(card?.id || "");
    setModalInstallment(fallbackInstallment);
    setPendingCheckoutAction(action);
    setShowPaymentModal(true);
  };

  const handlePaymentModalClose = () => {
    setShowPaymentModal(false);
    resetPaymentFlowState();
    setShowPaymentBreakdown(false);
  };

  const handleModalCardChange = (value) => {
    setShowPaymentBreakdown(false);
    setModalCard(value);
    const card = cardOptions.find((opt) => opt.id === value) || null;
    if (!card) {
      setModalInstallment("");
      return;
    }
    const isCurrentValid = card.installments?.some((opt) => Number(opt.value) === Number(modalInstallment));
    if (!isCurrentValid) {
      const first = card.installments?.[0];
      setModalInstallment(first ? String(first.value) : "");
    }
  };

  const handleAddFromList = (typeId) => {
    if (isPreview) return;
    // Tomar cantidad seleccionada; si no existe y es el tipo FREE_DEFAULT, usar 1 por defecto
    const fallback = typeId === 'FREE_DEFAULT' ? 1 : 0;
    const qty = Number(typeQuantities[typeId] ?? fallback);
    if (qty > 0) {
      trackAddToCartEvent({ ticketTypeId: typeId === "FREE_DEFAULT" ? null : typeId, quantity: qty, source: "event_detail_ticket_selector" });
    }
    setOrderQty(typeId, qty);
    // Sincronizar tambiÃ©n el selector visual cuando usamos default
    if ((typeQuantities[typeId] ?? undefined) === undefined && qty > 0) {
      setTypeQuantities((prev) => ({ ...prev, [typeId]: qty }));
    }
  };

  // Helpers para la orden derecha
  const setOrderQty = (typeId, qty) => {
    setOrderQuantities((prev) => {
      const next = { ...prev };
      const want = Math.max(0, Math.min(99, Number.isFinite(qty) ? qty : 0));
      const sumOthers = Object.entries(next)
        .filter(([k]) => k !== typeId)
        .reduce((s, [, q]) => s + (Number(q) || 0), 0);
      let perTypeCap = 99;
      try {
        if (typeId !== 'DEFAULT') {
          const t = (ticketTypes || []).find((tt) => tt.id === typeId);
          // `remaining` puede venir como `null` cuando el backend no tiene capacidad definida.
          // En ese caso no debe bloquear la selección (null != 0).
          const rawRemaining = t?.remaining;
          const hasRemainingValue =
            typeof rawRemaining !== 'undefined' &&
            rawRemaining !== null &&
            !(typeof rawRemaining === 'string' && rawRemaining.trim() === '');
          if (t && hasRemainingValue) {
            const remainingNum = Number(rawRemaining);
            if (Number.isFinite(remainingNum)) {
              perTypeCap = Math.min(99, Math.max(0, remainingNum));
            }
          }
        }
      } catch (_) {}
      const allowedLeft = Math.max(0, maxTicketsPerUser - (alreadyPurchased || 0));
      const maxForThis = Math.max(0, Math.min(perTypeCap, allowedLeft - sumOthers));
      const v = Math.min(want, maxForThis);
      if (want > v) {
        const left = Math.max(0, maxForThis);
        if (left <= 0) {
          toast.error(`Límite alcanzado: máximo ${maxTicketsPerUser} entradas por persona para este evento.`);
        } else {
          toast.error(`Máximo ${maxTicketsPerUser} entradas por persona para este evento. Podés seleccionar hasta ${left}.`);
        }
      }
      if (v > 0) next[typeId] = v; else delete next[typeId];
      return next;
    });
  };
  const incOrderQty = (typeId, maxPerType = 99) =>
    setOrderQuantities((prev) => {
      const next = { ...prev };
      const current = Number(next[typeId] || 0);
      const sumAll = Object.entries(next).reduce((s, [, q]) => s + (Number(q) || 0), 0);
      const allowedLeft = Math.max(0, maxTicketsPerUser - (alreadyPurchased || 0));
      if (sumAll >= allowedLeft) {
        toast.error(`Límite alcanzado: máximo ${maxTicketsPerUser} entradas por persona para este evento.`);
        return next;
      }
      const perTypeCap = Math.max(0, Math.min(99, maxPerType));
      next[typeId] = Math.min(perTypeCap, current + 1, allowedLeft - (sumAll - current));
      return next;
    });
  const decOrderQty = (typeId) =>
    setOrderQuantities((prev) => {
      const v = Math.max(0, Number(prev[typeId] || 0) - 1);
      const next = { ...prev };
      if (v > 0) next[typeId] = v; else delete next[typeId];
      return next;
    });

  const currentUser = useSelector((state) => state.auth.user);
  const needsDniForCheckout = () => {
    if (!token) return false;
    const role = String(currentUser?.role || "").toUpperCase();
    if (role === "ORGANIZER") return false;
    const cleaned = String(currentUser?.dni || "").replace(/\D+/g, "");
    return !cleaned;
  };
  const guardDniForCheckout = () => {
    if (!needsDniForCheckout()) return true;
    toast.error("Necesitas agregar tu DNI en tu perfil para continuar.");
    try { navigate("/account/profile"); } catch (_) {}
    return false;
  };
  // Al cerrar sesiÃ³n, limpiar selecciones locales inmediatamente
  useEffect(() => {
    if (isPreview) return;
    if (!token) {
      try {
        setOrderQuantities({});
        setTypeQuantities({});
        if (id) localStorage.removeItem(`draftOrder:${id}`);
      } catch (_) {}
    }
  }, [token, id, isPreview]);
  useEffect(() => {
    setModoError("");
  }, [orderQuantities, id]);
  // Sincroniza el carrito con la selecciÃ³n actual para poder iniciar el checkout
  const syncCartWithSelection = async () => {
    const entries = Object.entries(orderQuantities || {}).filter(([, q]) => (Number(q) || 0) > 0);
    const hasRealTypes = Array.isArray(ticketTypes) && ticketTypes.length > 0;
    const totalQty = entries.reduce((sum, [, q]) => sum + (Number(q) || 0), 0) || 1;

    try {
      const current = await getCartApi(token);
      const items = Array.isArray(current?.data?.info) ? current.data.info : [];
      for (const it of items) {
        try { await removeCartApi({ id: it?._id }, token); } catch (_) {}
      }
    } catch (_) {}

    if (hasRealTypes && entries.length > 0) {
      for (const [typeId, q] of entries) {
        const qty = Number(q) || 0;
        if (qty <= 0) continue;
        await addCartApi({ eventId: id, ticketTypeId: typeId, quantity: qty }, token);
      }
    } else {
      await addCartApi({ eventId: id, quantity: totalQty }, token);
    }

    return { hasRealTypes, totalQty };
  };

  const handleCheckoutFiserv = async ({ forcedSelection } = {}) => {
    let progressing = false;
    try {
      if (isPreview) {
        toast.info("Vista previa (solo lectura)");
        return;
      }
      if (isFreeOrder) {
        await handleCheckout();
        return;
      }

      const context = buildCheckoutContext();
      if (!context) {
        resetPaymentFlowState();
        return;
      }
      trackInitiateCheckout(context);

      if (!token) {
        let resumeKey = "";
        try {
          const r = await fetch(`${PAYMENT_API}/api/payment/fiserv/pending/save`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ eventid: id, items: context.items }),
          });
          const j = await r.json();
          if (r.ok && j?.info?.key) resumeKey = j.info.key;
        } catch (_) {}
        try {
          localStorage.setItem(
            "pendingCheckout",
            JSON.stringify({
              provider: "fiserv",
              eventId: id,
              quantities: orderQuantities,
              marketingConsent,
              resumeKey,
              ts: Date.now(),
            })
          );
        } catch {}
        navigate("/login", { state: { from: `/event/${id}`, reason: "checkout" } });
        return;
      }
      if (!guardDniForCheckout()) return;

      if (context.selectionIsFree) {
        progressing = true;
        setCheckingOut(true);
          const res = await createOrderApi(
            {
              eventid: id,
              quantity: context.totalQty,
              referralToken: referralToken || undefined,
              name: currentUser?.name || "",
              email: currentUser?.email || "",
            phone: currentUser?.phone || "",
            additionalInfo: "",
            state: "",
            items: context.items,
            marketingConsent,
          },
          token
        );
        if (res?.status === 200 && res?.data?.isSuccess) {
          navigate("/myevents");
        } else {
          throw new Error(res?.data?.message || "No se pudo crear la orden gratuita");
        }
        return;
      }

      if (!forcedSelection && pendingCheckoutAction !== "fiserv") {
        requirePaymentSelection("fiserv");
        return;
      }

      const selection = resolveConfirmedSelection(forcedSelection, context.selectionTotal);
      if (!selection || !selection.storeId || !selection.numberOfInstallments) {
        toast.error("Elegi la tarjeta y la cantidad de cuotas para continuar");
        if (!forcedSelection) {
          requirePaymentSelection("fiserv");
        }
        return;
      }

      const amounts = computeInstallmentAmounts(context, selection);

      selection.baseAmount = amounts.baseAmount;
      selection.totalWithInterest = amounts.chargeTotal;
      selection.surcharge = amounts.surcharge;
      selection.installmentAmount = amounts.installmentAmount;
      selection.rate = amounts.rate;

      progressing = true;
      setCheckingOut(true);

      const { id: uid, _id } = jwtDecode(token) || {};
      const userId = uid || _id;
      const body = {
        eventid: id,
        userId,
        referralToken: referralToken || undefined,
        name: currentUser?.name || "",
        email: currentUser?.email || "",
        phone: currentUser?.phone || "",
        items: context.items,
        storeId: selection.storeId,
        numberOfInstallments: selection.numberOfInstallments,
        marketingConsent,
      };
      if (Number.isFinite(amounts.effectiveRate)) body.installmentRate = amounts.effectiveRate;
      else if (Number.isFinite(amounts.rate)) body.installmentRate = amounts.rate;
      if (Number.isFinite(amounts.surcharge)) body.installmentSurcharge = amounts.surcharge;
      if (Number.isFinite(amounts.chargeTotal)) body.chargeTotal = amounts.chargeTotal;
      if (Number.isFinite(amounts.baseAmount)) body.baseAmount = amounts.baseAmount;
      if (Number.isFinite(amounts.installmentAmount)) body.installmentAmount = amounts.installmentAmount;

      const res = await fetch(`${PAYMENT_API}/api/payment/fiserv/connect/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(body),
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json?.message || "Error al iniciar el checkout");
      const href = json?.info?.href || json?.info?.checkoutUrl;
      const oid = json?.info?.orderId;
      if (!href) throw new Error("Checkout URL no recibido");
      const targetUrl = /^https?:\/\//i.test(href) ? href : `${PAYMENT_REDIRECT_BASE}${href}`;
      try {
        if (oid) localStorage.setItem("lastOrderId", oid);
        const ctx = {
          eventId: id,
          quantities: orderQuantities,
          cardId: selection.cardId || selection.card?.id,
          installments: selection.numberOfInstallments,
          storeId: selection.storeId,
          rate: amounts.rate,
          chargeTotal: amounts.chargeTotal,
        };
        localStorage.setItem("lastCheckoutCtx", JSON.stringify(ctx));
      } catch {}
      window.location.assign(targetUrl);
    } catch (error) {
      handleError(error);
    } finally {
      if (progressing) {
        setCheckingOut(false);
        resetPaymentFlowState();
      }
    }
  };
  const handleCheckout = async ({ forcedSelection } = {}) => {
    let progressing = false;
    try {
      if (isPreview) {
        toast.info("Vista previa (solo lectura)");
        return;
      }
      if (!token) {
        try {
          localStorage.setItem(
            "pendingCheckout",
            JSON.stringify({ provider: "fiserv", eventId: id, quantities: orderQuantities, marketingConsent, ts: Date.now() })
          );
        } catch {}
        navigate("/login", { state: { from: `/event/${id}`, reason: "checkout" } });
        return;
      }
      if (!guardDniForCheckout()) return;

      const context = buildCheckoutContext();
      if (!context) {
        resetPaymentFlowState();
        return;
      }
      trackInitiateCheckout(context);

      if (context.selectionIsFree) {
        progressing = true;
        setCheckingOut(true);
        const payload = {
          eventid: id,
          quantity: context.totalQty,
          referralToken: referralToken || undefined,
          name: currentUser?.name || "",
          email: currentUser?.email || "",
          phone: currentUser?.phone || "",
          additionalInfo: "",
          state: "",
          items: context.items,
          marketingConsent,
        };
        const res = await createOrderApi(payload, token);
        if (res?.status === 200 && res?.data?.isSuccess) {
          navigate("/myevents");
        } else {
          throw new Error(res?.data?.message || "No se pudo crear la orden gratuita");
        }
        return;
      }

      if (!forcedSelection && pendingCheckoutAction !== "checkout") {
        requirePaymentSelection("checkout");
        return;
      }

      const selection = resolveConfirmedSelection(forcedSelection, context.selectionTotal);
      if (!selection || !selection.storeId || !selection.numberOfInstallments) {
        toast.error("Elegi la tarjeta y la cantidad de cuotas para continuar");
        if (!forcedSelection) {
          requirePaymentSelection("checkout");
        }
        return;
      }

      const amounts = computeInstallmentAmounts(context, selection);

      selection.baseAmount = amounts.baseAmount;
      selection.totalWithInterest = amounts.chargeTotal;
      selection.surcharge = amounts.surcharge;
      selection.installmentAmount = amounts.installmentAmount;
      selection.rate = amounts.rate;

      progressing = true;
      setCheckingOut(true);

      const { id: uid, _id } = jwtDecode(token) || {};
      const userId = uid || _id;
      const body = {
        eventid: id,
        userId,
        referralToken: referralToken || undefined,
        name: currentUser?.name || "",
        email: currentUser?.email || "",
        phone: currentUser?.phone || "",
        items: context.items,
        storeId: selection.storeId,
        numberOfInstallments: selection.numberOfInstallments,
        marketingConsent,
      };
      if (Number.isFinite(amounts.effectiveRate)) body.installmentRate = amounts.effectiveRate;
      else if (Number.isFinite(amounts.rate)) body.installmentRate = amounts.rate;
      if (Number.isFinite(amounts.surcharge)) body.installmentSurcharge = amounts.surcharge;
      if (Number.isFinite(amounts.chargeTotal)) body.chargeTotal = amounts.chargeTotal;
      if (Number.isFinite(amounts.baseAmount)) body.baseAmount = amounts.baseAmount;
      if (Number.isFinite(amounts.installmentAmount)) body.installmentAmount = amounts.installmentAmount;

      const res = await fetch(`${PAYMENT_API}/api/payment/fiserv/connect/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(body),
      });

      const json = await res.json();
      if (!res.ok) throw new Error(json?.message || "Error al iniciar el checkout");

      const href = json?.info?.href || json?.info?.checkoutUrl;
      const oid = json?.info?.orderId;
      if (!href) throw new Error("Checkout URL no recibido");
      const targetUrl = /^https?:\/\//i.test(href) ? href : `${PAYMENT_REDIRECT_BASE}${href}`;
      try {
        if (oid) localStorage.setItem("lastOrderId", oid);
        const ctx = {
          eventId: id,
          quantities: orderQuantities,
          cardId: selection.cardId || selection.card?.id,
          installments: selection.numberOfInstallments,
          storeId: selection.storeId,
          rate: amounts.rate,
          chargeTotal: amounts.chargeTotal,
        };
        localStorage.setItem("lastCheckoutCtx", JSON.stringify(ctx));
      } catch {}
      window.location.assign(targetUrl);
    } catch (error) {
      handleError(error);
    } finally {
      if (progressing) {
        setCheckingOut(false);
        resetPaymentFlowState();
      }
    }
  };

  const handlePayWithModo = async () => {
    if (isPreview) {
      toast.info("Vista previa (solo lectura)");
      return;
    }
    if (modoLoading || checkingOut) return;
    setModoError("");

    // Paso 1: validar login y que exista una selección válida de tickets
    if (!token) {
      try {
        localStorage.setItem(
          "pendingCheckout",
          JSON.stringify({ provider: "modo", eventId: id, quantities: orderQuantities, marketingConsent, ts: Date.now() })
        );
      } catch {}
      navigate("/login", { state: { from: `/event/${id}`, reason: "checkout" } });
      return;
    }
    if (!guardDniForCheckout()) return;

    const context = buildCheckoutContext();
    if (!context) return;
    trackInitiateCheckout(context);
    if (context.selectionIsFree || isFreeOrder) {
      toast.info("Esta orden es gratuita. Usá el botón Canjear para finalizar.");
      return;
    }

    // Paso 2: armar el payload mínimo con ids, montos y comprador
    const amount = Number(context.selectionTotal ?? orderSubtotal ?? 0);
    if (!Number.isFinite(amount) || amount <= 0) {
      toast.error("Necesitamos un monto válido para iniciar el pago con MODO.");
      return;
    }
    const modoReference = `modo-${id}-${Date.now()}`;
      const payload = {
        eventId: id,
        orderId: modoReference,
        amount,
        quantity: context.totalQty,
        referralToken: referralToken || undefined,
        items: context.items,
        currency: (appSettings?.currency_string || appSettings?.currency || "ARS").toUpperCase(),
      buyerEmail: currentUser?.email || "",
      buyerName: currentUser?.name || "",
      buyerPhone: currentUser?.phone || "",
      marketingConsent,
    };

    const baseCandidates = [
      process.env.NEXT_PUBLIC_API_BASE_URL,
      process.env.NEXT_PUBLIC_API_BASE,
      PAYMENT_API,
    ].map((candidate) => (typeof candidate === "string" ? candidate.trim() : "")).filter((candidate) => candidate.length > 0);
    const normalizedBase = baseCandidates.length > 0 ? baseCandidates[0].replace(/\/$/, "") : "";
    const modoUrl = normalizedBase ? `${normalizedBase}/api/payments/modo` : "/api/payments/modo";

    // Paso 3: llamar al backend y redirigir al deeplink/URL provisto
    setModoLoading(true);
    try {
      const res = await fetch(modoUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(json?.message || "No se pudo iniciar el pago con MODO");
      }
      const redirectUrl =
        json?.redirectUrl ||
        json?.deeplink ||
        json?.deeplinkUrl ||
        json?.url ||
        json?.info?.redirectUrl ||
        json?.info?.deeplink;
      if (!redirectUrl) {
        throw new Error("El backend no devolvió la URL/deeplink de MODO");
      }
      window.location.assign(redirectUrl);
    } catch (error) {
      const message = error?.message || "No se pudo iniciar el pago con MODO";
      setModoError(message);
      toast.error(message);
    } finally {
      setModoLoading(false);
    }
  };

  const handleConfirmPaymentSelection = () => {
    if (!selectedCardOption) {
      toast.error("Elegi una tarjeta para continuar");
      return;
    }
    if (!selectedInstallmentOption) {
      toast.error("Elegi la cantidad de cuotas");
      return;
    }
    const initialSelection = {
      cardId: selectedCardOption.id,
      cardLabel: selectedCardOption.label,
      storeId: selectedCardOption.storeId,
      installments: Number(selectedInstallmentOption.value),
      numberOfInstallments: Number(selectedInstallmentOption.value),
      installmentLabel: selectedInstallmentOption.label,
      rate: Number(selectedInstallmentOption.rate || 0),
      baseAmount: Number(orderSubtotal) || 0,
      totalWithInterest: calculateInstallmentTotal(Number(orderSubtotal) || 0, Number(selectedInstallmentOption.rate || 0)),
    };
    const normalizedSelection = normalizeSelection(initialSelection, initialSelection.baseAmount);
    setConfirmedPaymentSelection(normalizedSelection);
    setShowPaymentModal(false);
    const action = pendingCheckoutAction;
    setTimeout(() => {
      if (action === "checkout") {
        handleCheckout({ forcedSelection: normalizedSelection });
      } else if (action === "fiserv") {
        handleCheckoutFiserv({ forcedSelection: normalizedSelection });
      }
    }, 0);
  };


  useEffect(() => {
    if (isPreview) {
      if (previewToken) {
        fetchEvent();
      } else {
        setPreviewError("Vista previa no disponible");
        setLoadingEvent(false);
      }
      return;
    }
    if (id) {
      fetchEvent();
      fetchEventSponsor();
      setNav((prev) => {
        if (prev.find((item) => item.path === `/event/${id}`)) {
          return prev;
        }
        return [
          {
            title: "Inicio",
            path: "/event",
          },
          {
            title: "Evento",
            path: "/event",
          },
          { title: state?.name, path: `/event/${id}` },
        ];
      });
    } else {
      navigate(-1);
    }
  }, [id, isPreview, previewToken]);
  // Reanudar checkout luego de login si habÃ­a una selecciÃ³n pendiente
  useEffect(() => {
    try {
      if (isPreview) return;
      const raw = localStorage.getItem("pendingCheckout");
      if (!raw) return;
      const data = JSON.parse(raw);
      if (!data || data.eventId !== id) return;
      if (!token) return; // esperar a que exista token
      // Restaurar cantidades en UI
      if (data.quantities && typeof data.quantities === 'object') {
        setOrderQuantities(data.quantities || {});
      }
      // Consumir el pending para no loop
      localStorage.removeItem("pendingCheckout");
      // No auto-redirigir: el usuario verÃ¡ la orden cargada y podrÃ¡ continuar manualmente
    } catch {}
  }, [id, token, isPreview]);
  useEffect(() => {
    AOS.init({
      disable: function () {
        return window.innerWidth < 900;
      },
    });
    fetchAppSettings();
  }, []);
  if (isLoading) return <SpinLoading />;
  if (isPreview && previewError) {
    return (
      <div className="preview-error">
        <div className="preview-error-card">
          <div className="preview-error-title">Vista previa no disponible</div>
          <div className="preview-error-text">{previewError}</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnFocusLoss draggable pauseOnHover theme="light" />
      {isPreview && (
        <div className="preview-banner"></div>
      )}
      {false && (
      <div className="eventdetailimage pading150 ">
        {!isTablet ? (
          <div className="eventdetailimage1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xlink="http://www.w3.org/1999/xlink"
              width="100%"
              height="492"
              viewBox="0 0 1140 492"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1140 20C1140 8.9543 1131.05 0 1120 0H20C8.95431 0 0 8.95432 0 20V472C0 483.046 8.9543 492 20 492H80C91.0457 492 100 483.046 100 472V412C100 400.954 108.954 392 120 392H1020C1031.05 392 1040 400.954 1040 412V472C1040 483.046 1048.95 492 1060 492H1120C1131.05 492 1140 483.046 1140 472V20Z"
                fill="url(#pattern0_422_548)"
                width="100%"
              />
              <defs>
                <pattern id="pattern0_422_548" patternContentUnits="objectBoundingBox" width="1" height="1">
                  <use href="#image0_422_548" transform="matrix(0.000750751 0 0 0.00173954 0 -0.239306)" />
                </pattern>
                <image
                  id="image0_422_548"
                  width="1332"
                  height="850"
                  href={event.image}
                  preserveAspectRatio="xMidYMid slice"
                />
              </defs>
            </svg>
          </div>
        ) : (
          <div className="eventdetailimage1">
            <img src={event.image} alt="event" />
          </div>
        )}
        <div className="eventdetails">
          <Row xs={1} sm={1} md={1} lg={5} xl={5}>
            <Col className="eventdetails1" data-aos="fade-up" data-aos-duration="200">
              <img src={DateIcon} alt="event" />
              <span className="eventdetails1title">Fecha de inicio</span>
              <span className="eventdetails1description">{dayjs(String(event.startDate || '').slice(0,10)).format("DD MMM YYYY")}</span>
            </Col>
            <Col className="eventdetails1" data-aos="fade-up" data-aos-duration="300">
              <img src={DateIcon} alt="event" />
              <span className="eventdetails1title">Fecha de fin</span>
              <span className="eventdetails1description">{dayjs(String(event.endDate || '').slice(0,10)).format("DD MMM YYYY")}</span>
            </Col>
            <Col className="eventdetails1" data-aos="fade-up" data-aos-duration="400">
              <img src={Time} alt="event" />
              <span className="eventdetails1title">Hora</span>
              <span className="eventdetails1description">
                de {dayjs(`2025-01-01 ${event.timeFrom}`, "YYYY-MM-DD HH:mm").format("hh:mm A")}
                <br /> a {dayjs(`2025-01-01 ${event.timeTo}`, "YYYY-MM-DD HH:mm").format("hh:mm A")}
                <br /> (UTC)
              </span>
            </Col>
            <Col className="eventdetails1" data-aos="fade-up" data-aos-duration="500">
              <img src={room} alt="event" />
              <span className="eventdetails1title">Sala</span>
              <span className="eventdetails1description">{event.room ? event.room : "-"}</span>
            </Col>
            <Col className="eventdetails1" data-aos="fade-up" data-aos-duration="600">
              <img src={Location} alt="event" />
              <span className="eventdetails1title">Ubicación</span>
              <span className="eventdetails1description">{event.fulladdress}</span>
            </Col>
          </Row>
        </div>
      </div>
      )}
      {false && (
        <div className="pading150 eventdetails2">
          <Row>
            <Col
              sm={3}
              md={3}
              className="eventdetails12"
              style={{ cursor: "pointer" }}
              onClick={() => {
                const q = getMapQuery(event);
                if (!q) return;
                window.open(`https://www.google.com/maps?q=${q}&z=15`, "_blank");
              }}
            >
              <img src={Location} alt="event" />

              <span className="eventdetails1title">Ubicación</span>
              <span className="eventdetails1description">{event.fulladdress}</span>
            </Col>
          </Row>
        </div>
      )}
      <div className="pading150 eventdetails3">
        <Row className="eventdetail-main-row">
          {!isTablet && !categoryhaderimage && (
            <Col>
              <Row>
                {desktopGalleryImage && (
                  <Col
                    sm={12}
                    md={12}
                    className="eventdetailsimage"
                    data-aos="fade-up"
                    data-aos-duration={200}
                    style={{ position: "relative" }}
                  >
                    <img
                      src={desktopGalleryImage}
                      alt="event"
                      className="eventdetails2image"
                      onClick={() => {
                        setImageview(true);
                        setImage(desktopGalleryImage);
                      }}
                    />
                    <button type="button" className="share-btn share-btn--tile" onClick={handleShare} aria-label="Compartir">
                      <img src={shareIcon} alt="" />
                    </button>
                    <button type="button" className="ig-btn ig-btn--tile" onClick={openInstagram} aria-label="Instagram">
                      <img src={instagramIcon} alt="" />
                    </button>
                  </Col>
                )}
              </Row>
            </Col>
          )}
          <Col className={`event-left eventdetails32 ${isMobile ? 'has-mobile-buybar' : ''}`}>
            <div
              className="left-scroll"
              ref={leftScrollRef}
              onScroll={handleLeftScrollEvent}
              onWheel={handleLeftGesture}
              onTouchMove={handleLeftGesture}
            >
            {heroImage && (
              <div className="event-hero" >
                <img
                  src={heroImage}
                  alt="event hero"
                  className="event-hero-img"
                />
                <button type="button" className="share-btn" onClick={handleShare} aria-label="Compartir">
                  <img src={shareIcon} alt="" />
                </button>
                <button type="button" className="ig-btn" onClick={openInstagram} aria-label="Instagram">
                  <img src={instagramIcon} alt="" />
                </button>
                {showScrollHint && (
                  <button type="button" className="scroll-hint" onClick={scrollDown}>
                    <img src={cherow} alt="bajar" className="arrow" />
                    <span>Deslizá para ver más</span>
                  </button>
                )}
              </div>
            )}
             <div className="eventdetails322" >
              {event.name}
            </div>
            <div className="event-meta-chips" >
              <div className="meta-chip">
                <img src={Calendar} alt="fecha" />
                <span>{dayjs(String(event.startDate || '').slice(0,10)).format("DD MMM YYYY")}</span>
              </div>
              <div className="meta-chip">
                <img src={reloj} alt="hora" />
                <span>{dayjs(`2025-01-01 ${event.timeFrom}`, "YYYY-MM-DD HH:mm").format("HH:mm")} hs</span>
              </div>
              {event?.fulladdress && (
                <div
                  className="meta-chip"
                  onClick={() => {
                    const q = getMapQuery(event);
                    if (q) window.open(`https://www.google.com/maps?q=${q}&z=15`, "_blank");
                  }}
                  style={{ cursor: getMapQuery(event) ? 'pointer' : 'default' }}
                >
                  <img src={ubi} alt="fecha" />
                  <span>{event.fulladdress}</span>
                </div>
              )}
              {event?.minAge >= 18 && (
                <div className="meta-chip">+{event.minAge}</div>
              )}
            </div>
            <div className="event-about-title" >Acerca del evento</div>
            <div className={`eventdetails323 ${isMobile && !descExpanded ? 'is-clamped' : ''}`} >
              {event.description}
            </div>
            {isMobile && (
              <button type="button" className={`more-info-btn ${descExpanded ? 'open' : ''}`} onClick={() => setDescExpanded(v => !v)}>
              <img src={cherow} alt="toggle" />
                <span>{descExpanded ? 'Ver menos' : 'Más info'}</span>
              </button>
            )}
            {/* Tipos de entradas */}
            {Array.isArray(uiTicketTypes) && uiTicketTypes.length > 0 ? (
              <div className="tickets-section" ref={ticketsRef} >
                <div className="tickets-title">Entradas</div>
                <div className="tickets-grid">
                  {uiTicketTypes.map((t) => {
                    const agotado = (t.remaining !== null && t.remaining <= 0) || !t.status || (String(event.endDate || '').slice(0,10) <= dayjs().format("YYYY-MM-DD"));
                    const maxPerType = Math.min(Number(t?.remaining ?? 99), 99);
                    const defaultQty = t.id === 'FREE_DEFAULT' ? 1 : 0;
                    const qty = Number(typeQuantities[t.id] ?? defaultQty);
                    const promoLabel = getPromotionLabel(t.promotion);
                    const chargedQty = getTypeChargedQty(t, qty);
                    return (
                      <div key={t.id} className="ticket-wrap">
                        <div className={`ticket-card1 ${agotado ? 'disabled' : ''}`}>
                          <div className="ticket-header">
                            <div className="ticket-name">{t.name}</div>
                          </div>
                          {resolveTicketsPerUnit(t) > 1 && (
                            <div className="ticket-line">
                              <span className="muted">Incluye</span>
                              <span>{resolveTicketsPerUnit(t)} entradas</span>
                            </div>
                          )}
                          {String(t.description || "").trim() && (() => {
                            const isExpanded = Boolean(expandedDescs[t.id]);
                            const words = t.description.split(/\s+/);
                            const preview = words.slice(0, 5).join(" ") + (words.length > 5 ? "..." : "");
                            return (
                              <>
                                <div 
                                  className="m-ticket-desc-preview" 
                                  onClick={() => toggleDesc(t.id)}
                                  style={{ marginTop: 2, marginBottom: 12 }}
                                >
                                  <span className="m-desc-text">
                                    {isExpanded ? "Ocultar descripción" : preview}
                                  </span>
                                  <button type="button" className="m-desc-arrow-btn" aria-label="Ver descripción">
                                    <svg 
                                      width="12" 
                                      height="12" 
                                      viewBox="0 0 24 24" 
                                      fill="none" 
                                      stroke="currentColor" 
                                      strokeWidth="2.5" 
                                      strokeLinecap="round" 
                                      strokeLinejoin="round"
                                      style={{ 
                                        transform: isExpanded ? 'rotate(-90deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.2s ease',
                                        marginLeft: 2
                                      }}
                                    >
                                      <path d="M9 18l6-6-6-6" />
                                    </svg>
                                  </button>
                                </div>
                                {isExpanded && (
                                  <div className="ticket-description">
                                    {t.description}
                                  </div>
                                )}
                              </>
                            );
                          })()}
                          <div className="ticket-line ticket-line-tarifa"><span className="muted">Tarifa</span><span className="price">{getTypePrice(t) === 0 ? 'Gratis' : `${appSettings.currency} ${Number(t.price || 0).toLocaleString()}`}</span></div>
                          {promoLabel && (
                            <div className="ticket-promo">
                              <span>{promoLabel}</span>
                              {qty > 0 && chargedQty < qty ? <small>Pagas {chargedQty} de {qty}</small> : null}
                            </div>
                          )}
                          <div className="ticket-line">
                            <span className="muted">Cantidad</span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <div className="m-stepper">
                                <button
                                  type="button"
                                  className="m-step"
                                  disabled={agotado || isPreview || qty <= 0}
                                  onClick={() => setQty(t.id, Math.max(0, qty - 1))}
                                  aria-label={`Quitar ${t.name}`}
                                >
                                  -
                                </button>
                                <input
                                  className="m-input"
                                  value={qty}
                                  disabled={agotado || isPreview}
                                  onChange={(e) => {
                                    const val = parseInt(e.target.value || 0);
                                    const maxLimit = Math.min(maxTicketsPerUser, maxPerType);
                                    setQty(t.id, Math.min(maxLimit, Math.max(0, val)));
                                  }}
                                />
                                <button
                                  type="button"
                                  className="m-step"
                                  disabled={agotado || isPreview || qty >= Math.min(maxTicketsPerUser, maxPerType)}
                                  onClick={() => setQty(t.id, qty + 1)}
                                  aria-label={`Agregar ${t.name}`}
                                >
                                  +
                                </button>
                              </div>
                              <button
                                type="button"
                                className="m-trash"
                                disabled={agotado || isPreview || qty <= 0}
                                onClick={() => setQty(t.id, 0)}
                                aria-label={`Eliminar ${t.name}`}
                              >
                                <img src={eliminar} alt="eliminar" />
                              </button>
                            </div>
                          </div>
                          <button
                            className="ticket-btn"
                            disabled={agotado || allowedLeft <= 0 || isPreview}
                            aria-disabled={agotado || allowedLeft <= 0 || isPreview}
                            title={allowedLeft <= 0 ? `Máximo ${maxTicketsPerUser} por persona alcanzado` : undefined}
                            onClick={() => handleAddFromList(t.id)}
                          >
                            {isPreview ? "Solo lectura" : "Agregar"}
                          </button>
                        </div>
                        {agotado ? (
                          <div className="ticket-foot sold">Agotado</div>
                        ) : (typeof t.remaining === 'number' && t.remaining < 10) ? (
                          <div className="ticket-foot ok">Quedan {t.remaining} tickets</div>
                        ) : null}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="eventdetails324" ref={ticketsRef} >
                <button
                  className="eventdetails324button"
                  disabled={loadingButtonId !== null || allowedLeft <= 0 || isPreview}
                  onClick={() => {
                    if (String(event.endDate || '').slice(0,10) > dayjs().format("YYYY-MM-DD")) {
                      if (event.maxbooking > event.totalbooking) {
                        // Ir directo al checkout desde el detalle
                        handleCheckout();
                      }
                    }
                  }}
                >
                  <span className="eventdetails324buttontransition"></span>
                  <span className="label">
                    {isPreview
                      ? "Solo lectura"
                      : (loadingButtonId === 'DEFAULT'
                        ? 'Procesando...'
                        : (
                            String(event.endDate || '').slice(0,10) > dayjs().format("YYYY-MM-DD")
                              ? (event.maxbooking > event.totalbooking ? "Entradas" : "No Ticket")
                              : "No Ticket"
                          ))}
                  </span>
                </button>
                <span className="eventdetails324price">
                  {event.isFree ? "Gratis" : appSettings.currency + " " + event.price}
                </span>
              </div>
            )}

            {/* Información útil */}
            <div className="info-section">
              <div className="info-title">Información útil</div>
              
              <ul className="info-list">
                {event?.doorsOpenTime && (
                  <li>Horario de apertura de puertas {dayjs(`2025-01-01 ${event.doorsOpenTime}`, 'YYYY-MM-DD HH:mm').format('HH:mm')}hs</li>
                )}
                {/* {event?.timeFrom && (
                  <li>Horario de comienzo del show {dayjs(`2025-01-01 ${event.timeFrom}`, 'YYYY-MM-DD HH:mm').format('HH:mm')}hs</li>
                )}
                {event?.timeFrom && event?.timeTo && (
                  <li>Duración del show {Math.max(0, dayjs(`2025-01-01 ${event.timeTo}`).diff(dayjs(`2025-01-01 ${event.timeFrom}`), 'minute'))}'</li>
                )} */}
              </ul>

              <div className="info-map">
                {(() => { const q = getMapQuery(event); return q ? (
                  <iframe
                    title="mapa"
                    width="100%"
                    height={isMobile ? "136" : "224"}
                    style={{ border: 0 }}
                    loading="lazy"
                    allowFullScreen
                    src={`https://www.google.com/maps?q=${q}&z=15&output=embed`}
                  />
                ) : (
                  <div className="info-empty">Mapa no disponible</div>
                ); })()}
              </div>

              {event?.fulladdress && (
                <div className="info-address">
                  <img src={ubi} alt="ubicación" />
                  <span>{event.fulladdress}</span>
                </div>
              )}

              {isMobile && (
                <div className="info-features">
                  <div className="info-feature">
                    <img src={ticket} alt="tickets" />
                    <span>Máx. {maxTicketsPerUser} tickets por persona</span>
                  </div>
                  <div className="info-feature">
                    <img src={qrscanner} alt="qr" />
                    <span>QR dinámico anti-fraude</span>
                  </div>
                  <div className="info-feature">
                    <img src={tranferencia} alt="transferencias" />
                    <span>Transferencias de tickets habilitadas 12hs antes del evento</span>
                  </div>
                </div>
              )}
            </div>

            <div className="waitlist">
              <img src={triste} alt="event" style={{width: 45, minHeight: 45}}/>
              <div className="waitlist-title">¿Sin tickets? Unite a la lista de espera</div>
              <div className="waitlist-text">Si se agotaron los tickets que querías no te preocupes, cuando se liberen te avisamos por orden de llegada</div>
              <form className="waitlist-form" onSubmit={handleWaitSubmit}>
                <input type="email" className="waitlist-input" placeholder="Email" value={waitEmail} onChange={(e)=> setWaitEmail(e.target.value)} />
                <button type="submit" className="waitlist-btn" disabled={!waitEmail}>Anotarme</button>
              </form>
              {waitSaved && <div className="waitlist-ok">Listo, te avisamos si hay cupos</div>}
            </div>
            </div>
          </Col>
          {/* Columna derecha: resumen de orden */}
          <Col lg={4} md={12} sm={12} xs={12} className="order-col">
            <div className="order-sticky">
              <div className="order-box">
              <div className="order-title">Orden de compra</div>
              {Array.isArray(uiTicketTypes) && uiTicketTypes.length > 0 && (
                <>
                  {Object.keys(orderQuantities || {}).length > 0 ? (
                    <div className="order-lines">
                      {uiTicketTypes.filter(tt => Number(orderQuantities[tt.id] || 0) > 0).map((t) => {
                        const agotado = (t.remaining !== null && t.remaining <= 0) || !t.status || (String(event.endDate || '').slice(0,10) <= dayjs().format("YYYY-MM-DD"));
                        const maxPerType = Math.min(Number(t?.remaining ?? 99), 99);
                        const q = Number(orderQuantities[t.id] || 0);
                        const promoLabel = getPromotionLabel(t.promotion);
                        const chargedQty = getTypeChargedQty(t, q);
                        return (
                          <div key={t.id} className={`order-line ${agotado ? 'disabled' : ''}`}>
                            <div className="order-line-name">
                              {t.name}
                              {resolveTicketsPerUnit(t) > 1 && (
                                <small className="order-promo-note">Incluye {resolveTicketsPerUnit(t)} entradas</small>
                              )}
                              {promoLabel && <small className="order-promo-note">{promoLabel}{chargedQty < q ? ` · pagas ${chargedQty}` : ""}</small>}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <div className="m-stepper">
                                <button
                                  type="button"
                                  className="m-step"
                                  disabled={agotado || isPreview || q <= 0}
                                  onClick={() => setOrderQty(t.id, Math.max(0, q - 1))}
                                  aria-label={`Quitar ${t.name}`}
                                >
                                  -
                                </button>
                                <input
                                  className="m-input"
                                  value={q}
                                  disabled={agotado || isPreview}
                                  onChange={(e) => {
                                    const val = parseInt(e.target.value || 0);
                                    const maxLimit = Math.min(maxTicketsPerUser, maxPerType);
                                    setOrderQty(t.id, Math.min(maxLimit, Math.max(0, val)));
                                  }}
                                />
                                <button
                                  type="button"
                                  className="m-step"
                                  disabled={agotado || isPreview || q >= Math.min(maxTicketsPerUser, maxPerType)}
                                  onClick={() => setOrderQty(t.id, q + 1)}
                                  aria-label={`Agregar ${t.name}`}
                                >
                                  +
                                </button>
                              </div>
                              <button
                                type="button"
                                className="m-trash"
                                disabled={agotado || isPreview || q <= 0}
                                onClick={() => setOrderQty(t.id, 0)}
                                aria-label={`Eliminar ${t.name}`}
                              >
                                <img src={eliminar} alt="eliminar" />
                              </button>
                            </div>
                            <div className="order-line-price">{getTypeDisplayPrice(t, q)}</div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="order-empty">Tu orden está vacía</div>
                  )}
                </>
              )}
              {/* LÃ­nea de servicio tachada */}
              <div className="order-line muted"><div className="order-line-name"><span className="strike">Servicio</span></div><div className="order-line-price strike">{appSettings.currency} {serviceFee.toLocaleString()}</div></div>
              <div className="order-separator"></div>
              <div className="order-total">
                <div className="order-total-row order-total-highlight">
                  <div>TOTAL</div>
                  <div>{appSettings.currency} {orderSubtotal.toLocaleString()}</div>
                </div>
              </div>
              <div className="order-note order-note-highlight">ZOCO te muestra el costo final con todo incluido. El precio que ves es el que pagás</div>
              {allowedLeft <= 0 ? (
                <div className="order-note" style={{ color: '#d00', fontWeight: 600 }}>
                  Alcanzaste el máximo de {maxTicketsPerUser} tickets para este evento.
                </div>
              ) : (
                <div className="order-note" style={{ color: '#555' }}>
                  Máx. {maxTicketsPerUser} por persona. Ya tenés {alreadyPurchased}; podés seleccionar hasta {allowedLeft}.
                </div>
              )}
              <div className="order-optin-wrap">
                <label className="order-optin">
                  <input
                    type="checkbox"
                    checked={organizerMarketingOptIn}
                    onChange={(e) => setOrganizerMarketingOptIn(e.target.checked)}
                    disabled={isPreview}
                  />
                  <span>Quiero recibir correos electrónicos y notificaciones sobre las últimas noticias de este organizador</span>
                </label>
                {/*<div className="order-optin-hint">Por el momento, solo email (próximamente WhatsApp y notificaciones).</div>*/}
              </div>
              <div className="order-actions">
                <button
                  className="order-btn primary modo-btn"
                  onClick={handlePayWithModo}
                  disabled={modoLoading || checkingOut || isOrderEmpty || exceedsMax || isFreeOrder || isPreview}
                  aria-disabled={modoLoading || checkingOut || isOrderEmpty || exceedsMax || isFreeOrder || isPreview}
                  title={
                    isOrderEmpty
                      ? 'Tu orden está vacía'
                      : (isFreeOrder ? 'Este evento es gratuito: usá Canjear' : undefined)
                  }
                >
                  <span className="modo-btn-label">
                    <span className="modo-btn-line">
                      <span>{modoLoading ? 'Redirigiendo...' : ''}</span>
                      {!modoLoading && <img src={modo} alt="MODO" className="modo-logo" />}
                    </span>
 
                  </span>
                </button>
                <button
                  className="order-btn primary"
                  onClick={handleCheckout}
                  disabled={checkingOut || modoLoading || isOrderEmpty || exceedsMax || isPreview}
                  aria-disabled={checkingOut || modoLoading || isOrderEmpty || exceedsMax || isPreview}
                  title={isOrderEmpty ? 'Tu orden está vacía' : undefined}
                >
                  {isPreview ? 'Solo lectura' : (checkingOut ? 'Procesando...' : (isFreeOrder ? 'Canjear' : 'Pagar'))}
                </button>
              </div>
              {modoError && (
                <div className="order-error" role="alert">{modoError}</div>
              )}
              <div className="order-accept">Aceptamos tarjetas y wallets locales</div>
              <div className="order-logos">
                <img src={visa} alt="visa"style={{width: 38, height: 15}}/>
                <img src={maestro} alt="maestro" style={{width: 25, height: 19}}/>
                <img src={mastercard} alt="mastercard" style={{width: 25, height: 19}}/>
                <img src={american} alt="american" style={{width: 38, height: 15}}/>
                <img src={argencard} alt="argencard"style={{width: 23, height: 24}} />
                <img src={dinners} alt="diners" style={{width: 30, height: 22}}/>
                <img src={cabal} alt="cabal" style={{width: 37, height: 15}}/>
                </div>
                <div className="order-logos1">
                <img src={mp} alt="mp" style={{width: 38, height: 15}}/>
                <img src={bna} alt="bna" style={{width: 38, height: 15}}/>
                <img src={uala} alt="uala" style={{width: 38, height: 15}}/>
                <img src={claropay} alt="claropay"style={{width: 38, height: 15}} />
                <img src={modo} alt="modo" style={{width: 38, height: 15}}/>
                <img src={naranja} alt="naranja" style={{width: 38, height: 15}}/>
                <img src={personal} alt="personal" style={{width: 38, height: 15}}/>
                <img src={cuentaDni} alt="cuenta dni" style={{width: 38, height: 15}}/>
              </div>
            </div>
             <div className="order-box1">
              <div><img src={ticket} alt="cuenta dni" style={{width: 18, height: 18, marginRight:8}}/> Máx. {maxTicketsPerUser} tickets por persona</div>
              <div><img src={qrscanner} alt="cuenta dni" style={{width: 20, height: 20, marginRight:8}}/>QR dinámico anti-fraude</div>
              <div className="transferencia"><img src={tranferencia} alt="cuenta dni" style={{width: 17, height: 17, marginRight:8}}/>Transferencias habilitadas 12hs antes del evento</div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      {false && event?.venueid?.latitude && event?.venueid?.longitude && (
        <div className="pading150 eventdetails7">
          <div className="contactus-map-container">
            <div className="eventdetails71">
              <iframe
                src={`https://www.google.com/maps?q=${event?.venueid?.latitude},${event?.venueid?.longitude}&z=13&output=embed`}
                width="100%"
                style={{ border: 0 }}
                className="contactus-map"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map"
              />
            </div>

            <div className="contactus-info">
              <img src={Location} alt="location" width={20} height={20} /> {event.fulladdress}
            </div>
          </div>
        </div>
      )}
      {false && day.length > 0 && (
        <div style={{ height: "100%" }} className={`${isTablet ? "pading150" : "paddingright150"} eventdetails4`}>
          <div>
            <Row xs={1} sm={1} md={1} lg={2} xl={2} style={{ height: "100%" }}>
              <Col
                className=" eventdetails41 "
                style={{ backgroundColor: "#e5e8ee", paddingRight: "0px", paddingLeft: "0px" }}
              >
                <div className="paddingleft150 eventdetails411">
                  <span className="eventdetails411title">Schedule</span>
                  <span className="eventdetails411description">Plan your day with ease and precision!</span>
                </div>
                {day.map((item, index) => (
                  <div
                    className={`paddingleft150 eventdetails412`}
                    style={{
                      backgroundColor: activeday === item._id ? "#eaf0f5" : " #e5e8ee",
                      transition: "all 0.3s ease-in-out",
                    }}
                    onClick={() => {
                      setActiveday(item?._id);
                      fetchSessio(item?._id);
                    }}
                  >
                    <span className="eventdetails412title">{item.name}</span>
                    <span
                      className="eventdetails412description"
                      style={{
                        display: activeday === item._id ? "block" : "none",
                        transition: "all 0.3s ease-in-out",
                      }}
                    >
                      {dayjs(item.date).format("DD MMM, YYYY")}
                    </span>
                  </div>
                ))}
              </Col>
              <Col>
                {session.map((item, index) => (
                  <Row key={index} className="eventpresenterlistsession">
                    <Col xs={4} sm={4} md={4} lg={4} xl={4} key={index}>
                      <Row>
                        {item.presenter.map((itemSession, indexSession) => (
                          <Col
                            sm={item.presenter.length === 1 ? 12 : 6}
                            md={item.presenter.length === 1 ? 12 : 6}
                            lg={item.presenter.length === 1 ? 12 : 6}
                            xl={item.presenter.length === 1 ? 12 : 6}
                            className="eventpresenterlist"
                            key={indexSession}
                          >
                            <img src={itemSession.image} alt="event" className="eventpresenterlistimage" />
                          </Col>
                        ))}
                      </Row>
                    </Col>
                    <Col xs={8} sm={8} md={8} lg={8} xl={8} className="eventpresenterlist2">
                      <div className="eventpresenterlist21">
                        <span className="eventpresenterlisttime">
                          {item.starttime} - {item.endtime}
                        </span>

                        <span className="eventpresenterlisttitle">{item.title}</span>
                        <span className="eventpresenterlistdescription">{item.description}</span>
                        <span className="eventpresenterlistpresenter">
                          {item.presenter.map((itemPresenter) => (
                            <span className="eventpresenterlistpresenteritem">
                              {itemPresenter.name}-{" "}
                              <span className="eventpresenterlistpresenteritemdescription">
                                {itemPresenter.position}
                              </span>
                            </span>
                          ))}
                        </span>
                      </div>
                    </Col>
                  </Row>
                ))}
              </Col>
            </Row>
          </div>
        </div>
      )}
      {/* <Row
        xs={1}
        sm={1}
        md={1}
        lg={1}
        xl={1}
        className="pading150 eventdetails5"
        style={{ width: "100%", margin: "0px" }}
      >
        <Col className="eventdetails411title">LEAVE A REPLY</Col>
        <Col className="eventdetails51description">Share your thoughts and join the conversation!</Col>
        <Col className="">
          <Card className="eventdetails51inputcard">
            <Card.Body style={{ padding: "0px" }}>
              <Row style={{ marginBottom: "10px" }}>
                <Col>
                  <span style={{ fontSize: "14px", fontWeight: "600", color: "#0D263C" }}>
                    Rating:{" "}
                    <Rating
                      allowFraction
                      onClick={(rate) => {
                        
                        setRating(rate);
                      }}
                      transition
                      initialValue={3}
                      size={20}
                      fillColor="#EC6325"
                    />
                  </span>
                </Col>
              </Row>

              <Form className="row" noValidate onSubmit={handleSubmit(onSubmit)}>
                <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                  <Form.Group controlId="name" className="eventdetails51group">
                    <Form.Control
                      type="text"
                      placeholder="Name*"
                      autoComplete="off"
                      className="eventdetails51input"
                      {...register("name", { required: "Please enter your name." })}
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">{errors.name?.message}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                  <Form.Group controlId="email" className="eventdetails51group">
                    <Form.Control
                      type="email"
                      placeholder="Email*"
                      autoComplete="off"
                      className="eventdetails51input"
                      {...register("email", {
                        required: "Please enter a valid email.",
                        pattern: {
                          value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
                          message: "Invalid email format.",
                        },
                      })}
                      isInvalid={!!errors.email}
                    />
                    <Form.Control.Feedback type="invalid">{errors.email?.message}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

              
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Form.Group controlId="subject" className="eventdetails51group">
                    <Form.Control
                      type="text"
                      placeholder="Your Subject*"
                      autoComplete="off"
                      className="eventdetails51input"
                      {...register("subject", { required: "Please enter your subject." })}
                      isInvalid={!!errors.subject}
                    />
                    <Form.Control.Feedback type="invalid">{errors.subject?.message}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Form.Group controlId="comment" className="eventdetails51group">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      autoComplete="off"
                      placeholder="Comment*"
                      className="eventdetails51input"
                      {...register("comment", { required: "Please enter your comment." })}
                      isInvalid={!!errors.comment}
                    />
                    <Form.Control.Feedback type="invalid">{errors.comment?.message}</Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="eventdetails51buttoncol">
                  <button type="submit" className="eventdetails51button">
                    {reviewstate ? (
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    ) : (
                      "Post Comment"
                    )}
                  </button>
                </Col>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row> */}
      {false && relatedevent.length > 0 && (
        <Row xs={1} sm={1} md={1} lg={1} xl={1} style={{ width: "100%", margin: "0px", backgroundColor: "#0b0b0f" }}>
          <Col className="pading150">
            <Row>
              <Col sm={12} md={12} lg={12} className="category1">
                <span>EVENTOS RELACIONADOS</span>
              </Col>
              <Col sm={12} md={12} lg={12} className="relatedevent2">
                <span>Descubre eventos que se ajustan a tus intereses y dan vida a tus pasiones</span>
              </Col>
            </Row>
          </Col>
          <Col style={{ padding: "0px", width: "100%" }}>
            <Swiper
              slidesPerView={3.4}
              spaceBetween={20}
              pagination={{ el: ".swiper-pagination-bullets-relatedevent", clickable: true }}
              navigation={{ prevEl: ".arrow-relatedevent.first", nextEl: ".arrow-relatedevent.last" }}
              className="mySwiperrelatedevent paddingleft150"
              modules={[Pagination, Navigation]}
              onSwiper={(swiper) => {
                swipereventRef.current = swiper;
              }}
              // style={{ padding: "0px" }}
              breakpoints={{
                1400: {
                  slidesPerView: 3.4,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 2.2,
                  spaceBetween: 20,
                },
                768: { slidesPerView: 2.2, spaceBetween: 20 },
                425: { slidesPerView: 1.3, spaceBetween: 10 },
                0: { slidesPerView: 1.2, spaceBetween: 5 },
              }}
            >
              {relatedevent.map((item, index) => (
                <SwiperSlide key={index} className="eventdetails521 ">
                  {" "}
                  <Card className="eventlist4">
                    <div className="eventlistimagecontainer">
                      <Card.Img
                        variant="top"
                        className="eventlistimage"
                        src={isMobile ? (item.mobileimage || item.image) : item.image}
                      />
                      <div className="eventlistimageoverlay">{item.isFree ? "" : `$${item.price}`}</div>
                      <div className="eventlistimageoverlay2">{dayjs(String(item.startDate || '').slice(0,10)).format("DD MMM, YYYY")}</div>
                    </div>

                    <Card.Body>
                      <Card.Title className="eventlistcardtitle">{item.name}</Card.Title>
                      <Card.Text className="eventlistcardtext">
                        <div>
                          <svg
                            width="16"
                            height="20"
                            viewBox="0 0 16 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8 0C3.85813 0 0.5 3.35813 0.5 7.5C0.5 9.13094 1.03469 10.6275 1.92344 11.8531C1.93938 11.8825 1.94187 11.9153 1.96 11.9434L6.96 19.4434C7.19188 19.7913 7.5825 20 8 20C8.4175 20 8.80812 19.7913 9.04 19.4434L14.04 11.9434C14.0584 11.9153 14.0606 11.8825 14.0766 11.8531C14.9653 10.6275 15.5 9.13094 15.5 7.5C15.5 3.35813 12.1419 0 8 0ZM8 10C6.61937 10 5.5 8.88062 5.5 7.5C5.5 6.11937 6.61937 5 8 5C9.38062 5 10.5 6.11937 10.5 7.5C10.5 8.88062 9.38062 10 8 10Z"
                              fill="#bac819"
                            />
                          </svg>
                        </div>
                        <div className="eventlistlocation">{item.fulladdress}</div>
                      </Card.Text>
                      <div className="eventlistcardbutton">
                        <Button
                          className="eventlistbutton"
                          onClick={() => {
                            // setNav([
                            //   {
                            //     title: "Home",
                            //     path: "/",
                            //   },
                            //   {
                            //     title: "Event",
                            //     path: `/event`,
                            //   },
                            //   {
                            //     title: item.name,
                            //     path: `/event/${item._id}`,
                            //   },
                            // ]);
                            // fetchEvent();
                            navigate(`/event/${item._id}`, { state: { name: item.name } });
                          }}
                        >
                          <span class="eventlistbuttontransition"></span>
                          <span class="eventlistbuttonlabel">
                            {item.endDate > dayjs().format("YYYY-MM-DD")
                              ? item.maxbooking > item.totalbooking
                                ? "Obtener entrada"
                                : "Sin entradas"
                              : "Sin entradas"}
                          </span>
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="custom-pagination-relatedevent">
              <button className="arrow-relatedevent first" onClick={handleFirstClick} style={{ marginRight: "5px" }}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.219639 6.53021C-0.0732538 6.23732 -0.0732538 5.76244 0.219639 5.46955L4.71964 0.969548C5.01253 0.676655 5.48741 0.676655 5.7803 0.969548C6.07319 1.26244 6.07319 1.73732 5.7803 2.03021L2.56063 5.24988L11.25 5.24988C11.6642 5.24988 12 5.58566 12 5.99988C12 6.41409 11.6642 6.74988 11.25 6.74988L2.56063 6.74988L5.7803 9.96955C6.07319 10.2624 6.07319 10.7373 5.7803 11.0302C5.48741 11.3231 5.01253 11.3231 4.71964 11.0302L0.219639 6.53021Z"
                    fill="#8F99A2"
                  />
                </svg>
              </button>

              <div className="swiper-pagination-bullets-relatedevent"></div>

              <button className="arrow-relatedevent last" onClick={handleLastClick} style={{ marginLeft: "5px" }}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.7803 5.46967C12.0732 5.76256 12.0732 6.23744 11.7803 6.53033L7.28033 11.0303C6.98744 11.3232 6.51256 11.3232 6.21967 11.0303C5.92678 10.7374 5.92678 10.2626 6.21967 9.96967L9.43934 6.75L0.75 6.75C0.335787 6.75 0 6.41421 0 6C0 5.58579 0.335787 5.25 0.75 5.25L9.43934 5.25L6.21967 2.03033C5.92678 1.73744 5.92678 1.26256 6.21967 0.96967C6.51256 0.676777 6.98744 0.676777 7.28033 0.96967L11.7803 5.46967Z"
                    fill="#8F99A2"
                  />
                </svg>
              </button>
            </div>
          </Col>
        </Row>
      )}
      {isMobile && !isPreview && (
        <div className="mobile-buybar">
          <button
            type="button"
            className="buy-btn"
            onClick={() => {
              const pixelId = getResolvedMetaPixelId(event || {});
              if (loadMetaPixel(pixelId)) {
                trackMetaPixel("ViewContent", {
                  content_name: event?.title || event?.name || "Evento",
                  content_ids: [String(event?._id || event?.id || id || "event")],
                  content_type: "event",
                  source: "mobile_buy_bar",
                });
              }
              setShowOrderModal(true);
            }}
          >
            Comprar entradas
          </button>
        </div>
      )}
      {false && eventSponsor.length > 0 && (
        <Row style={{ padding: "0px", width: "100%" }}>
          <Col className="eventdetails6">
            <span>PATROCINADORES DEL EVENTO</span>
            <Marquee className="sponser">
              {eventSponsor.map((item) => (
                <img className="sponserimg" src={item.image} alt="" />
              ))}
            </Marquee>
          </Col>
        </Row>
      )}
      <Modal show={showPaymentModal} onHide={handlePaymentModalClose} centered backdrop="static" className="payment-modal">
        <Modal.Header closeButton>
          <Modal.Title>Elegí cómo pagar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Tarjeta</label>
            <QtySelect
              className="payment-select"
              placeholder="Elegí una tarjeta"
              value={modalCard}
              onChange={(val) => handleModalCardChange(val == null ? "" : String(val))}
              options={(cardOptions || []).map((opt) => ({
                value: opt.id,
                label: opt.label,
                disabled: opt.disabled,
              }))}
            />
          </div>
          {selectedCardOption && (
            <div className="mb-3">
              <label className="form-label">Cuotas</label>
              <QtySelect
                className="payment-select"
                placeholder="Elegí la cantidad de cuotas"
                value={modalInstallment}
                disabled={!installmentOptions?.length}
                onChange={(val) => setModalInstallment(val == null ? "" : String(val))}
                options={(installmentOptions || []).map((opt) => {
                  const count = Number(opt.value) || 0;
                  const baseLabel = opt.label || `${count} cuota${count === 1 ? "" : "s"}`;
                  const totalWithRate = calculateInstallmentTotal(orderSubtotal, opt.rate ?? 0);
                  const perInstallment = count > 0 ? totalWithRate / count : totalWithRate;
                  const displayLabel = count > 0 ? `${baseLabel} de ${formatCurrency(perInstallment)}` : baseLabel;
                  return {
                    value: String(opt.value),
                    label: displayLabel,
                    disabled: opt.disabled,
                  };
                })}
              />
            </div>
          )}
          {showInstallmentSummary && (
            <>
              <button
                type="button"
                className="payment-summary-toggle mb-3"
                onClick={() => setShowPaymentBreakdown((prev) => !prev)}
                aria-expanded={showPaymentBreakdown}
                aria-controls="payment-breakdown"
              >
                {showPaymentBreakdown ? "Ocultar detalle" : "Ver detalle de costos"}
              </button>
              {showPaymentBreakdown && (
                <div id="payment-breakdown" className="payment-summary border rounded p-3">
                  <div className="payment-detail-row">
                    <span className="payment-detail-label">Sub Total</span>
                    <span className="payment-detail-value">{formatCurrency(orderSubtotal)}</span>
                  </div>
                  {modalInterestAmount > 0 && (
                    <div className="payment-detail-row">
                      <span className="payment-detail-label">Interés</span>
                      <span className="payment-detail-value">{formatCurrency(modalInterestAmount)}</span>
                    </div>
                  )}
                  <div className="payment-detail-row">
                    <span className="payment-detail-label">TOTAL</span>
                    <span className="payment-detail-value">{formatCurrency(modalTotalWithInterest)}</span>
                  </div>
                  
                </div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlePaymentModalClose}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirmPaymentSelection}
            disabled={!selectedCardOption || !selectedInstallmentOption}
          >
            Continuar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={visible} onHide={() => setVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Video</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <video style={{ width: "100%", height: "100%" }} src={video} controls autoPlay controlsList="nodownload" />
        </Modal.Body>
      </Modal>
      {/* Mobile order modal */}
      {!isPreview && (
      <Modal
        show={isMobile && showOrderModal}
        onHide={() => setShowOrderModal(false)}
        centered
        dialogClassName="mobile-order-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Entradas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Lines for all ticket types or fallback */}
          <div className="m-order-lines">
            {Array.isArray(uiTicketTypes) && uiTicketTypes.length > 0 ? (
              uiTicketTypes.map((t) => {
                const maxPerType = Math.min(Number(t?.remaining ?? 99), maxTicketsPerUser);
                const q = Number(orderQuantities[t.id] || 0);
                const agotado = (t.remaining !== null && t.remaining <= 0) || !t.status || (String(event.endDate || '').slice(0,10) <= dayjs().format("YYYY-MM-DD"));
                const promoLabel = getPromotionLabel(t.promotion);
                const chargedQty = getTypeChargedQty(t, q);
                return (
                  <div key={t.id} className={`m-order-line ${agotado ? 'disabled' : ''}`}>
                    <div className="m-row-top">
                      <div className="m-name">{t.name}</div>
                      <div className="m-price">{getTypeDisplayPrice(t, q)}</div>
                    </div>
                    {resolveTicketsPerUnit(t) > 1 && (
                      <div className="m-promo">Incluye {resolveTicketsPerUnit(t)} entradas</div>
                    )}
                    {promoLabel && <div className="m-promo">{promoLabel}{chargedQty < q ? ` · pagas ${chargedQty}` : ""}</div>}
                    {String(t.description || "").trim() ? (() => {
                      const words = t.description.split(/\s+/);
                      const preview = words.slice(0, 5).join(" ") + (words.length > 5 ? "..." : "");
                      return (
                        <div 
                          className="m-ticket-desc-preview" 
                          onClick={() => setSelectedTicketDesc({ name: t.name, description: t.description, ticketsPerUnit: resolveTicketsPerUnit(t) })}
                        >
                          <span className="m-desc-text">{preview}</span>
                          <button type="button" className="m-desc-arrow-btn" aria-label="Ver descripción completa">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M9 18l6-6-6-6" />
                            </svg>
                          </button>
                        </div>
                      );
                    })() : null}
                    {agotado ? (
                      <div className="m-soldout">Agotado</div>
                    ) : (
                      <div className="m-row-bottom">
                        <div className="m-qty-left">
                          <div className="m-qty-label">Cant.</div>
                        </div>
                        <div className="m-qty-right">
                          <div className="m-stepper">
                            <button type="button" className="m-step" onClick={() => decOrderQty(t.id)} aria-label={`Quitar ${t.name}`}>-</button>
                            <input className="m-input" value={q} onChange={(e)=> setOrderQty(t.id, Math.min(maxPerType, Math.max(0, parseInt(e.target.value||0))))} />
                            <button type="button" className="m-step" onClick={() => incOrderQty(t.id, maxPerType)} aria-label={`Agregar ${t.name}`}>+</button>
                          </div>
                          <button type="button" className="m-trash" onClick={() => setOrderQty(t.id, 0)} aria-label={`Eliminar ${t.name}`}>
                            <img src={eliminar} alt="eliminar" />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="m-order-line">
                <div className="m-row-top">
                  <div className="m-name">General</div>
                  <div className="m-price">{Number(event?.price||0) <=0 ? 'Gratis' : `${appSettings.currency} ${Number(event?.price||0).toLocaleString()}`}</div>
                </div>
                <div className="m-row-bottom">
                  <div className="m-qty-left">
                    <div className="m-qty-label">Cant.</div>
                  </div>
                  <div className="m-qty-right">
                    <div className="m-stepper">
                      <button type="button" className="m-step" onClick={() => decOrderQty('DEFAULT')}>-</button>
                      <input className="m-input" value={Number(orderQuantities['DEFAULT']||0)} onChange={(e)=> setOrderQty('DEFAULT', Math.min(maxTicketsPerUser, Math.max(0, parseInt(e.target.value||0))) || 0)} />
                      <button type="button" className="m-step" onClick={() => incOrderQty('DEFAULT', maxTicketsPerUser)}>+</button>
                    </div>
                    <button type="button" className="m-trash" onClick={() => setOrderQty('DEFAULT', 0)} aria-label="Eliminar">
                      <img src={eliminar} alt="eliminar" />
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="m-order-sep"></div>
          <div className="m-order-service"><span className="strike">Servicio</span><span className="strike">{appSettings.currency} {serviceFee.toLocaleString()}</span></div>
          <div className="m-order-total"><span>TOTAL</span><span>{appSettings.currency} {orderSubtotal.toLocaleString()}</span></div>
          <div className="m-order-optin-wrap">
            <label className="m-order-optin">
              <input
                type="checkbox"
                checked={organizerMarketingOptIn}
                onChange={(e) => setOrganizerMarketingOptIn(e.target.checked)}
              />
              <span>Quiero recibir correos electrónicos y notificaciones sobre las últimas noticias de este organizador</span>
            </label>
            <div className="m-order-optin-hint">Por el momento, solo email (próximamente WhatsApp y notificaciones).</div>
          </div>
          <div className="m-order-actions">
            <button
              className="m-btn primary modo-btn"
              onClick={handlePayWithModo}
              disabled={modoLoading || checkingOut || isOrderEmpty || exceedsMax || isFreeOrder}
              aria-disabled={modoLoading || checkingOut || isOrderEmpty || exceedsMax || isFreeOrder}
              title={
                isOrderEmpty
                  ? 'Tu orden está vacía'
                  : (isFreeOrder ? 'Este evento es gratuito: usá Canjear' : undefined)
              }
            >
              <span className="modo-btn-label">
                <span className="modo-btn-line">
                  <span>{modoLoading ? 'Redirigiendo...' : ''}</span>
                  {!modoLoading && <img src={modo} alt="MODO" className="modo-logo" />}
                </span>
              </span>
            </button>
            <button
              className="m-btn primary"
              onClick={handleCheckout}
              disabled={checkingOut || modoLoading || isOrderEmpty || exceedsMax}
              aria-disabled={checkingOut || modoLoading || isOrderEmpty || exceedsMax}
            >{checkingOut ? 'Procesando...' : (isFreeOrder ? 'Canjear' : 'Pagar')}</button>
          </div>
          {modoError && (
            <div className="order-error" role="alert">{modoError}</div>
          )}
          <div className="m-order-note m-order-note-highlight">ZOCO te muestra el costo final con todo incluido. El precio que ves es el que pagás</div>
        </Modal.Body>
      </Modal>
      )}
      <Modal backdrop="static" show={imageview} onHide={() => setImageview(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Imagen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img style={{ width: "100%", height: "100%" }} src={image} alt="event" className="eventdetails2image" />
        </Modal.Body>
      </Modal>
      <Modal
        show={Boolean(selectedTicketDesc)}
        onHide={() => setSelectedTicketDesc(null)}
        centered
        dialogClassName="ticket-desc-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedTicketDesc?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ whiteSpace: "pre-line", fontSize: "15px", color: "#2D3035", lineHeight: "1.5" }}>
          {selectedTicketDesc?.description}
        </Modal.Body>
      </Modal>
      <FloatingAppButton />
    </>
  );
};

export default EventDetail;

